var qr = Object.defineProperty;
var Kr = (e, r, t) => r in e ? qr(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var me = (e, r, t) => (Kr(e, typeof r != "symbol" ? r + "" : r, t), t);
import { j as d } from "./jsx-runtime.mjs";
import ot, { useState as _, useEffect as S, useMemo as ee, useRef as F, useCallback as O, useImperativeHandle as Tr, cloneElement as Sr, useContext as ne, forwardRef as Nr, createContext as Xr } from "react";
import { b as y, B as Ce, O as Ne, E as he, U as je, C as _e, P as qt, F as Kt, a as Xt, d as Zt, H as Qt, e as Jt, f as Ke, h as W, R as Xe, i as Ze, j as Yt, k as Zr, l as Qe, m as Je, n as Ye, c as Ve, o as Qr, p as Be, q as er, M as Jr, g as Yr } from "./index.mjs";
import { p as c, h as U, j as tr, s as et, b as jr, f as H, M as Le, d as en, g as tn } from "./config.mjs";
import { linkTo as rn, draggingScroll as nn, debounce as on, createSmoothScroll as an, uuid as tt } from "@vavt/util";
import { EditorView as be } from "codemirror";
import { placeholder as ln, EditorView as at, keymap as sn } from "@codemirror/view";
import { languages as cn } from "@codemirror/language-data";
import { markdown as dn } from "@codemirror/lang-markdown";
import { EditorSelection as fe, EditorState as ze, Compartment as pe, StateEffect as un } from "@codemirror/state";
import { deleteLine as mn, defaultKeymap as fn, historyKeymap as gn, indentWithTab as hn, history as rr, undo as bn, redo as pn } from "@codemirror/commands";
import { indentUnit as vn, HighlightStyle as Ar, syntaxHighlighting as Er } from "@codemirror/language";
import { tags as w } from "@lezer/highlight";
import { autocompletion as xn } from "@codemirror/autocomplete";
import { searchKeymap as kn } from "@codemirror/search";
import wn from "medium-zoom";
import yn from "copy-to-clipboard";
import Cn from "markdown-it";
import $n from "markdown-it-image-figures";
import Tn from "markdown-it-task-lists";
import { LRUCache as Sn } from "lru-cache";
import { createPortal as Nn } from "react-dom";
function jn(e, r) {
  for (var t = 0; t < r.length; t++) {
    const n = r[t];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const o in n)
        if (o !== "default" && !(o in e)) {
          const i = Object.getOwnPropertyDescriptor(n, o);
          i && Object.defineProperty(e, o, i.get ? i : {
            enumerable: !0,
            get: () => n[o]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
function An(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
const En = (e, r) => {
  const t = (n) => {
    const o = e.parentElement || document.body, i = o.offsetWidth, l = o.offsetHeight, { clientWidth: m, clientHeight: s } = document.documentElement, a = n.offsetX, u = n.offsetY, f = (h) => {
      let p = h.x + document.body.scrollLeft - document.body.clientLeft - a, v = h.y + document.body.scrollTop - document.body.clientTop - u;
      p = p < 1 ? 1 : p < m - i - 1 ? p : m - i - 1, v = v < 1 ? 1 : v < s - l - 1 ? v : s - l - 1, r ? r(p, v) : (o.style.left = p + "px", o.style.top = v + "px");
    };
    document.addEventListener("mousemove", f);
    const b = () => {
      document.removeEventListener("mousemove", f), document.removeEventListener("mouseup", b);
    };
    document.addEventListener("mouseup", b);
  };
  return e.addEventListener("mousedown", t), () => {
    e.removeEventListener("mousedown", t);
  };
}, le = (e, r, t = "") => {
  var o;
  const n = document.getElementById(r.id);
  if (n)
    t !== "" && (Reflect.get(window, t) ? (o = r.onload) == null || o.call(n, new Event("load")) : r.onload && n.addEventListener("load", r.onload));
  else {
    const i = { ...r };
    i.onload = null;
    const l = In(e, i);
    r.onload && l.addEventListener("load", r.onload), document.head.appendChild(l);
  }
}, Ln = (e, r) => {
  const t = document.getElementById(r.id);
  t == null || t.remove(), le(e, r);
}, In = (e, r) => {
  const t = document.createElement(e);
  return Object.keys(r).forEach((n) => {
    r[n] !== void 0 && (t[n] = r[n]);
  }), t;
}, Hn = (e, r) => {
  const { modelValue: t, onSave: n } = e, { editorId: o } = r, [i, l] = _({
    // 是否已编译成html
    buildFinished: !1,
    // 存储当前最新的html
    html: ""
  });
  S(() => {
    const m = (s) => {
      l(() => ({
        buildFinished: !0,
        html: s
      }));
    };
    return y.on(o, {
      name: Ce,
      callback: m
    }), () => {
      y.remove(o, Ce, m);
    };
  }, [o]), S(() => {
    const m = () => {
      if (n) {
        const s = new Promise((a) => {
          if (i.buildFinished)
            a(i.html);
          else {
            const u = (f) => {
              a(f), y.remove(o, Ce, u);
            };
            y.on(o, {
              name: Ce,
              callback: u
            });
          }
        });
        n(t, s);
      }
    };
    return y.on(o, {
      name: Ne,
      callback: m
    }), () => {
      y.remove(o, Ne, m);
    };
  }, [o, t, n, i.buildFinished, i.html]), S(() => {
    l((m) => ({
      ...m,
      buildFinished: !1
    }));
  }, [t]);
}, Pn = (e) => {
  const { noPrettier: r, noUploadImg: t } = e;
  S(() => {
    const { editorExtensions: n, editorExtensionsAttrs: o } = U, i = r || !!n.prettier.prettierInstance, l = r || !!n.prettier.parserMarkdownInstance;
    if (!(t || !!n.cropper.instance)) {
      const { js: s = {}, css: a = {} } = o.cropper || {};
      le("link", {
        ...a,
        rel: "stylesheet",
        href: n.cropper.css,
        id: `${c}-cropperCss`
      }), le("script", {
        ...s,
        src: n.cropper.js,
        id: `${c}-cropper`
      });
    }
    if (!i) {
      const { standaloneJs: s = {} } = o.prettier || {};
      le("script", {
        ...s,
        src: n.prettier.standaloneJs,
        id: `${c}-prettier`
      });
    }
    if (!l) {
      const { parserMarkdownJs: s = {} } = o.prettier || {};
      le("script", {
        ...s,
        src: n.prettier.parserMarkdownJs,
        id: `${c}-prettierMD`
      });
    }
  }, [r, t]), Mn(e);
}, Mn = ({ noIconfont: e }) => {
  S(() => {
    const { editorExtensions: r, editorExtensionsAttrs: t, iconfontType: n } = U;
    e || (n === "svg" ? le("script", {
      ...t.iconfont,
      src: r.iconfont,
      id: `${c}-icon`
    }) : le("link", {
      ...t.iconfontClass,
      rel: "stylesheet",
      href: r.iconfontClass,
      id: `${c}-icon-class`
    }));
  }, [e]);
}, Dn = (e, r) => {
  S(() => (y.on(e, {
    name: he,
    callback: r
  }), () => {
    y.remove(e, he, r);
  }), [e, r]);
}, Rn = (e, r) => {
  const { editorId: t } = r, { onUploadImg: n } = e;
  S(() => {
    const o = (i, l) => {
      const m = (s) => {
        y.emit(t, W, "image", {
          desc: "",
          urls: s
        }), l && l();
      };
      n == null || n(i, m);
    };
    return y.on(t, {
      name: je,
      callback: o
    }), () => {
      y.remove(t, je, o);
    };
  }, [t, n]);
}, _n = (e, r) => {
  const { toolbars: t = jr, toolbarsExclude: n = [] } = e, { editorId: o } = r, [i, l] = _(!1);
  return S(() => {
    const s = (a) => {
      l(a === void 0 ? (u) => !u : a);
    };
    return y.on(o, {
      name: _e,
      callback: s
    }), () => {
      y.remove(o, _e, s);
    };
  }, [o]), ee(() => !n.includes("catalog") && t.includes("catalog") && i, [i, t, n]);
};
let nr = "";
const Fn = (e) => {
  const {
    theme: r = H.theme,
    preview: t = H.preview,
    htmlPreview: n = H.htmlPreview,
    pageFullscreen: o = H.pageFullscreen,
    previewTheme: i = H.previewTheme,
    codeTheme: l = H.codeTheme,
    language: m = H.language,
    codeStyleReverse: s = H.codeStyleReverse,
    codeStyleReverseList: a = H.codeStyleReverseList
  } = e, u = ee(() => {
    const g = U.editorExtensions.highlight, x = U.editorExtensionsAttrs.highlight, { js: k } = g, $ = {
      ...tr,
      ...g.css
    }, { js: C, css: T = {} } = x || {}, N = s && a.includes(i) ? "dark" : r, P = $[l] ? $[l][N] : tr.atom[N], L = $[l] && T[l] ? T[l][N] : T.atom ? T.atom[N] : {};
    return {
      js: {
        src: k,
        ...C
      },
      css: {
        href: P,
        ...L
      }
    };
  }, [s, a, i, r, l]), f = ee(() => {
    const g = {
      ...et,
      ...U.editorConfig.languageUserDefined
    };
    return g[m] ? g[m] : et["zh-CN"];
  }, [m]), [b, h] = _({
    pageFullscreen: o,
    fullscreen: !1,
    preview: t,
    htmlPreview: t ? !1 : n,
    previewOnly: !1
  }), p = F(b), v = O((g, x) => {
    const k = x === void 0 ? !b[g] : x;
    h(($) => {
      const C = {
        ...$
      };
      switch (g) {
        case "preview": {
          C.htmlPreview = !1, C.previewOnly = !1;
          break;
        }
        case "htmlPreview": {
          C.preview = !1, C.previewOnly = !1;
          break;
        }
        case "previewOnly": {
          k ? !C.preview && !C.htmlPreview && (C.preview = !0) : (p.current.preview || (C.preview = !1), p.current.htmlPreview || (C.htmlPreview = !1));
          break;
        }
      }
      return p.current[g] = k, C[g] = k, C;
    });
  }, []);
  return S(() => {
    nr = document.body.style.overflow;
  }, []), S(() => {
    b.pageFullscreen || b.fullscreen ? document.body.style.overflow = "hidden" : document.body.style.overflow = nr;
  }, [b.pageFullscreen, b.fullscreen]), [u, f, b, v];
}, On = (e, r, t, n, o, i) => {
  const { editorId: l } = r;
  S(() => {
    y.emit(l, qt, n.pageFullscreen);
  }, [l, n.pageFullscreen]), S(() => {
    y.emit(l, Kt, n.fullscreen);
  }, [l, n.fullscreen]), S(() => {
    y.emit(l, Xt, n.preview);
  }, [l, n.preview]), S(() => {
    y.emit(l, Zt, n.previewOnly);
  }, [l, n.previewOnly]), S(() => {
    y.emit(l, Qt, n.htmlPreview);
  }, [l, n.htmlPreview]), S(() => {
    y.emit(l, Jt, t);
  }, [t, l]), Tr(
    e,
    () => ({
      on(s, a) {
        switch (s) {
          case "pageFullscreen": {
            y.on(l, {
              name: qt,
              callback(u) {
                a(u);
              }
            });
            break;
          }
          case "fullscreen": {
            y.on(l, {
              name: Kt,
              callback(u) {
                a(u);
              }
            });
            break;
          }
          case "preview": {
            y.on(l, {
              name: Xt,
              callback(u) {
                a(u);
              }
            });
            break;
          }
          case "previewOnly": {
            y.on(l, {
              name: Zt,
              callback(u) {
                a(u);
              }
            });
            break;
          }
          case "htmlPreview": {
            y.on(l, {
              name: Qt,
              callback(u) {
                a(u);
              }
            });
            break;
          }
          case "catalog": {
            y.on(l, {
              name: Jt,
              callback(u) {
                a(u);
              }
            });
            break;
          }
        }
      },
      togglePageFullscreen(s) {
        o("pageFullscreen", s);
      },
      toggleFullscreen(s) {
        y.emit(l, Ke, s);
      },
      togglePreview(s) {
        o("preview", s);
      },
      togglePreviewOnly(s) {
        o("previewOnly", s);
      },
      toggleHtmlPreview(s) {
        o("htmlPreview", s);
      },
      toggleCatalog(s) {
        y.emit(l, _e, s);
      },
      triggerSave() {
        y.emit(l, Ne);
      },
      insert(s) {
        y.emit(l, W, "universal", { generate: s });
      },
      focus(s) {
        var a;
        (a = i.current) == null || a.focus(s);
      },
      rerender() {
        y.emit(l, Xe);
      },
      getSelectedText() {
        var s;
        return (s = i.current) == null ? void 0 : s.getSelectedText();
      },
      resetHistory() {
        var s;
        (s = i.current) == null || s.resetHistory();
      },
      domEventHandlers(s) {
        y.emit(l, Ze, s);
      },
      execCommand(s) {
        y.emit(l, W, s);
      }
    }),
    [i, l, o]
  );
}, Vn = () => /* @__PURE__ */ d.jsx("div", { className: `${c}-divider` }), or = `${c}-dropdown-hidden`, we = (e) => {
  const { relative: r = "html" } = e, [t, n] = _({
    overlayClass: or,
    overlayStyle: {}
  }), o = F({
    triggerHover: !1,
    overlayHover: !1
  }), i = F(null), l = F(null), m = O(() => {
    var D, V;
    o.current.triggerHover = !0;
    const v = i.current, g = l.current;
    if (!v || !g)
      return;
    const x = v.getBoundingClientRect(), k = v.offsetTop, $ = v.offsetLeft, C = x.height, T = x.width, N = ((D = document.querySelector(r)) == null ? void 0 : D.scrollLeft) || 0, P = ((V = document.querySelector(r)) == null ? void 0 : V.clientWidth) || 0;
    let L = $ - g.offsetWidth / 2 + T / 2 - N;
    L + g.offsetWidth > N + P && (L = N + P - g.offsetWidth), L < 0 && (L = 0), n((B) => ({
      ...B,
      overlayStyle: {
        top: k + C + "px",
        left: L + "px"
      }
    })), e.onChange(!0);
  }, [e, r]), s = () => {
    o.current.overlayHover = !0;
  };
  S(() => {
    e.visible ? n((v) => ({
      ...v,
      overlayClass: ""
    })) : n((v) => ({
      ...v,
      overlayClass: or
    }));
  }, [e.visible]);
  const a = F(-1), u = O(
    (v) => {
      i.current === v.target ? o.current.triggerHover = !1 : o.current.overlayHover = !1, clearTimeout(a.current), a.current = window.setTimeout(() => {
        !o.current.overlayHover && !o.current.triggerHover && e.onChange(!1);
      }, 10);
    },
    [e]
  );
  S(() => {
    var v, g, x, k;
    return (v = i.current) == null || v.addEventListener("mouseenter", m), (g = i.current) == null || g.addEventListener("mouseleave", u), (x = l.current) == null || x.addEventListener("mouseenter", s), (k = l.current) == null || k.addEventListener("mouseleave", u), () => {
      var $, C, T, N;
      ($ = i.current) == null || $.removeEventListener("mouseenter", m), (C = i.current) == null || C.removeEventListener("mouseleave", u), (T = l.current) == null || T.removeEventListener("mouseenter", s), (N = l.current) == null || N.removeEventListener("mouseleave", u);
    };
  }, [u, m]);
  const f = e.children, b = e.overlay, h = Sr(f, {
    ref: i,
    key: "cloned-dropdown-trigger"
  }), p = /* @__PURE__ */ d.jsx(
    "div",
    {
      className: `${c}-dropdown ${t.overlayClass}`,
      style: t.overlayStyle,
      ref: l,
      children: /* @__PURE__ */ d.jsx("div", { className: `${c}-dropdown-overlay`, children: b instanceof Array ? b[0] : b })
    }
  );
  return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    h,
    p
  ] });
}, Wn = (e) => U.iconfontType === "svg" ? /* @__PURE__ */ d.jsx("svg", { className: `${c}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ d.jsx("use", { xlinkHref: `#${c}-icon-${e.name}` }) }) : /* @__PURE__ */ d.jsx("i", { className: `${c}-iconfont ${c}-icon-${e.name}` }), Bn = Wn, R = (e) => {
  const { customIcon: r } = ne(te), t = r[e.name];
  if (typeof t == "object") {
    const n = t.component;
    return typeof n == "function" ? /* @__PURE__ */ d.jsx(n, { ...t.props }) : /* @__PURE__ */ d.jsx(
      "span",
      {
        dangerouslySetInnerHTML: {
          __html: t.component
        }
      }
    );
  }
  return /* @__PURE__ */ d.jsx(Bn, { name: e.name });
}, zn = `${c}-modal-container`, Lr = (e) => {
  const { theme: r } = ne(te), { onClose: t = () => {
  }, onAdjust: n = () => {
  }, style: o = {}, showMask: i = !0 } = e, [l, m] = _(e.visible), [s, a] = _([`${c}-modal`]), u = F(null), f = F(null), b = F(), h = F(null), [p, v] = _({
    maskStyle: {
      zIndex: -1
    },
    modalStyle: {
      zIndex: -1
    },
    initPos: {
      left: "0px",
      top: "0px"
    },
    historyPos: {
      left: "0px",
      top: "0px"
    }
  }), g = ee(() => e.isFullscreen ? {
    width: "100%",
    height: "100%"
  } : {
    width: e.width,
    height: e.height
  }, [e.height, e.isFullscreen, e.width]);
  return S(() => (b.current = document.body, () => {
    b.current = void 0;
  }), []), S(() => {
    let x = () => {
    };
    return !e.isFullscreen && e.visible && (x = En(
      f.current,
      (k, $) => {
        v((C) => ({
          ...C,
          initPos: {
            left: k + "px",
            top: $ + "px"
          }
        }));
      }
    )), x;
  }, [e.isFullscreen, e.visible]), S(() => {
    if (l) {
      const x = u.current.offsetWidth / 2, k = u.current.offsetHeight / 2, $ = document.documentElement.clientWidth / 2, C = document.documentElement.clientHeight / 2;
      v((T) => ({
        ...T,
        maskStyle: {
          zIndex: U.editorConfig.zIndex + Yt()
        },
        modalStyle: {
          zIndex: U.editorConfig.zIndex + Yt()
        },
        initPos: {
          left: $ - x + "px",
          top: C - k + "px"
        }
      }));
    }
  }, [l]), S(() => {
    const x = e.visible;
    x ? (a(() => [`${c}-modal`, "zoom-in"]), m(x)) : (a(() => [`${c}-modal`, "zoom-out"]), setTimeout(() => {
      m(x);
    }, 150));
  }, [e.visible]), /* @__PURE__ */ d.jsx(d.Fragment, { children: b.current && Nn(
    /* @__PURE__ */ d.jsx("div", { ref: h, className: zn, "data-theme": r, children: /* @__PURE__ */ d.jsxs(
      "div",
      {
        className: e.className,
        style: { ...o, display: l ? "block" : "none" },
        children: [
          i && /* @__PURE__ */ d.jsx(
            "div",
            {
              className: `${c}-modal-mask`,
              style: p.maskStyle,
              onClick: t
            }
          ),
          /* @__PURE__ */ d.jsxs(
            "div",
            {
              className: s.join(" "),
              style: {
                ...p.modalStyle,
                ...p.initPos,
                ...g
              },
              ref: u,
              children: [
                /* @__PURE__ */ d.jsx("div", { className: `${c}-modal-header`, ref: f, children: e.title || "" }),
                /* @__PURE__ */ d.jsxs("div", { className: `${c}-modal-func`, children: [
                  e.showAdjust && /* @__PURE__ */ d.jsx(
                    "div",
                    {
                      className: `${c}-modal-adjust`,
                      onClick: (x) => {
                        x.stopPropagation(), e.isFullscreen ? v((k) => ({
                          ...k,
                          initPos: k.historyPos
                        })) : v((k) => ({
                          ...k,
                          historyPos: k.initPos,
                          initPos: {
                            left: "0",
                            top: "0"
                          }
                        })), n instanceof Function && n(!e.isFullscreen);
                      },
                      children: /* @__PURE__ */ d.jsx(R, { name: e.isFullscreen ? "suoxiao" : "fangda" })
                    }
                  ),
                  /* @__PURE__ */ d.jsx(
                    "div",
                    {
                      className: `${c}-modal-close`,
                      onClick: (x) => {
                        x.stopPropagation(), e.onClose && e.onClose();
                      },
                      children: /* @__PURE__ */ d.jsx(R, { name: "close" })
                    }
                  )
                ] }),
                /* @__PURE__ */ d.jsx("div", { className: `${c}-modal-body`, children: e.children })
              ]
            }
          )
        ]
      }
    ) }),
    b.current
  ) });
}, Gn = (e) => {
  var l, m, s, a, u;
  const { editorId: r, usedLanguageText: t } = ne(te), n = ee(() => {
    var f, b;
    switch (e.type) {
      case "link":
        return (f = t.linkModalTips) == null ? void 0 : f.linkTitle;
      case "image":
        return (b = t.linkModalTips) == null ? void 0 : b.imageTitle;
      default:
        return "";
    }
  }, [e.type, t]), [o, i] = _({
    desc: "",
    url: ""
  });
  return S(() => {
    e.visible || setTimeout(() => {
      i({
        desc: "",
        url: ""
      });
    }, 200);
  }, [e.visible]), ee(() => {
    var f, b, h, p, v;
    return /* @__PURE__ */ d.jsxs(Lr, { title: n, visible: e.visible, onClose: e.onCancel, children: [
      /* @__PURE__ */ d.jsxs("div", { className: `${c}-form-item`, children: [
        /* @__PURE__ */ d.jsx("label", { className: `${c}-label`, htmlFor: `link-desc-${r}`, children: (f = t.linkModalTips) == null ? void 0 : f.descLabel }),
        /* @__PURE__ */ d.jsx(
          "input",
          {
            placeholder: (b = t.linkModalTips) == null ? void 0 : b.descLabelPlaceHolder,
            className: `${c}-input`,
            id: `link-desc-${r}`,
            type: "text",
            value: o.desc,
            onChange: (g) => {
              i((x) => ({
                ...x,
                desc: g.target.value
              }));
            }
          }
        )
      ] }),
      /* @__PURE__ */ d.jsxs("div", { className: `${c}-form-item`, children: [
        /* @__PURE__ */ d.jsx("label", { className: `${c}-label`, htmlFor: `link-url-${r}`, children: (h = t.linkModalTips) == null ? void 0 : h.urlLabel }),
        /* @__PURE__ */ d.jsx(
          "input",
          {
            placeholder: (p = t.linkModalTips) == null ? void 0 : p.urlLabelPlaceHolder,
            className: `${c}-input`,
            id: `link-url-${r}`,
            type: "text",
            value: o.url,
            onChange: (g) => {
              i((x) => ({
                ...x,
                url: g.target.value
              }));
            }
          }
        )
      ] }),
      /* @__PURE__ */ d.jsx("div", { className: `${c}-form-item`, children: /* @__PURE__ */ d.jsx(
        "button",
        {
          className: `${c}-btn ${c}-btn-row`,
          type: "button",
          onClick: () => {
            e.onOk(o), i((g) => ({
              ...g,
              desc: "",
              url: ""
            }));
          },
          children: (v = t.linkModalTips) == null ? void 0 : v.buttonOK
        }
      ) })
    ] });
  }, [
    n,
    e,
    r,
    (l = t.linkModalTips) == null ? void 0 : l.descLabel,
    (m = t.linkModalTips) == null ? void 0 : m.descLabelPlaceHolder,
    (s = t.linkModalTips) == null ? void 0 : s.urlLabel,
    (a = t.linkModalTips) == null ? void 0 : a.urlLabelPlaceHolder,
    (u = t.linkModalTips) == null ? void 0 : u.buttonOK,
    o
  ]);
}, Un = Gn;
let de = null;
const qn = (e) => {
  var h, p;
  const r = ne(te), { editorId: t, usedLanguageText: n } = r, o = U.editorExtensions.cropper.instance, i = F(null), l = F(null), m = F(null), [s, a] = _({
    cropperInited: !1,
    imgSelected: !1,
    imgSrc: "",
    // 是否全屏
    isFullscreen: !1
  });
  S(() => {
    e.visible && !s.cropperInited && (window.Cropper = o || window.Cropper, i.current.onchange = () => {
      if (!window.Cropper) {
        y.emit(t, he, {
          name: "Cropper",
          message: "Cropper is undefined"
        });
        return;
      }
      const v = i.current.files || [];
      if ((v == null ? void 0 : v.length) > 0) {
        const g = new FileReader();
        g.onload = (x) => {
          a((k) => ({
            ...k,
            imgSelected: !0,
            imgSrc: x.target.result
          }));
        }, g.readAsDataURL(v[0]);
      }
    });
  }, [e.visible, s.cropperInited, o, t]), S(() => {
    s.imgSrc && (de = new window.Cropper(l.current, {
      viewMode: 2,
      preview: `.${c}-clip-preview-target`
      // aspectRatio: 16 / 9,
    }));
  }, [s.imgSrc]), S(() => {
    var v;
    (v = m.current) == null || v.setAttribute("style", "");
  }, [s.imgSelected]), S(() => {
    var v;
    de == null || de.destroy(), (v = m.current) == null || v.setAttribute("style", ""), l.current && (de = new window.Cropper(l.current, {
      viewMode: 2,
      preview: `.${c}-clip-preview-target`
      // aspectRatio: 16 / 9,
    }));
  }, [s.isFullscreen]);
  const u = ee(() => s.isFullscreen ? {
    width: "100%",
    height: "100%"
  } : {
    width: "668px",
    height: "392px"
  }, [s.isFullscreen]), f = () => {
    de.clear(), de.destroy(), de = null, i.current.value = "", a((v) => ({
      ...v,
      imgSrc: "",
      imgSelected: !1
    }));
  }, b = O((v) => {
    a((g) => ({
      ...g,
      isFullscreen: v
    }));
  }, []);
  return ee(() => {
    var v, g;
    return /* @__PURE__ */ d.jsxs(
      Lr,
      {
        className: `${c}-modal-clip`,
        title: (v = n.clipModalTips) == null ? void 0 : v.title,
        visible: e.visible,
        onClose: e.onCancel,
        showAdjust: !0,
        isFullscreen: s.isFullscreen,
        onAdjust: b,
        ...u,
        children: [
          /* @__PURE__ */ d.jsxs("div", { className: `${c}-form-item ${c}-clip`, children: [
            /* @__PURE__ */ d.jsx("div", { className: `${c}-clip-main`, children: s.imgSelected ? /* @__PURE__ */ d.jsxs("div", { className: `${c}-clip-cropper`, children: [
              /* @__PURE__ */ d.jsx(
                "img",
                {
                  src: s.imgSrc,
                  ref: l,
                  style: { display: "none" },
                  alt: ""
                }
              ),
              /* @__PURE__ */ d.jsx("div", { className: `${c}-clip-delete`, onClick: f, children: /* @__PURE__ */ d.jsx(R, { name: "delete" }) })
            ] }) : /* @__PURE__ */ d.jsx(
              "div",
              {
                className: `${c}-clip-upload`,
                onClick: () => {
                  i.current.click();
                },
                children: /* @__PURE__ */ d.jsx(R, { name: "upload" })
              }
            ) }),
            /* @__PURE__ */ d.jsx("div", { className: `${c}-clip-preview`, children: /* @__PURE__ */ d.jsx("div", { className: `${c}-clip-preview-target`, ref: m }) })
          ] }),
          /* @__PURE__ */ d.jsx("div", { className: `${c}-form-item`, children: /* @__PURE__ */ d.jsx(
            "button",
            {
              className: `${c}-btn`,
              type: "button",
              onClick: () => {
                if (de) {
                  const x = de.getCroppedCanvas();
                  y.emit(
                    t,
                    je,
                    [Zr(x.toDataURL("image/png"))],
                    e.onOk
                  ), f();
                }
              },
              children: (g = n.linkModalTips) == null ? void 0 : g.buttonOK
            }
          ) }),
          /* @__PURE__ */ d.jsx(
            "input",
            {
              ref: i,
              accept: "image/*",
              type: "file",
              multiple: !1,
              style: { display: "none" }
            }
          )
        ]
      }
    );
  }, [
    (h = n.clipModalTips) == null ? void 0 : h.title,
    (p = n.linkModalTips) == null ? void 0 : p.buttonOK,
    e.visible,
    e.onCancel,
    e.onOk,
    s.isFullscreen,
    s.imgSelected,
    s.imgSrc,
    b,
    u,
    t
  ]);
}, Kn = qn, Xn = (e) => /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
  /* @__PURE__ */ d.jsx(
    Un,
    {
      type: e.type,
      visible: e.linkVisible,
      onOk: e.onOk,
      onCancel: e.onCancel
    }
  ),
  /* @__PURE__ */ d.jsx(
    Kn,
    {
      visible: e.clipVisible,
      onOk: e.onOk,
      onCancel: e.onCancel
    }
  )
] }), Zn = Xn, Qn = (e) => {
  const [r, t] = _({
    x: -1,
    y: -1
  }), n = O(() => {
    const l = [...e.tableShape];
    return (!l[2] || l[2] < l[0]) && (l[2] = l[0]), (!l[3] || l[3] < l[3]) && (l[3] = l[1]), l;
  }, [e.tableShape]), [o, i] = _(n);
  return S(() => {
    i(n);
  }, [n]), /* @__PURE__ */ d.jsx(
    "div",
    {
      className: `${c}-table-shape`,
      onMouseLeave: () => {
        i(n), t({
          x: -1,
          y: -1
        });
      },
      children: new Array(o[1]).fill("").map((l, m) => /* @__PURE__ */ d.jsx("div", { className: `${c}-table-shape-row`, children: new Array(o[0]).fill("").map((s, a) => /* @__PURE__ */ d.jsx(
        "div",
        {
          className: `${c}-table-shape-col`,
          onMouseEnter: () => {
            t({
              x: m,
              y: a
            }), a + 1 === o[0] && a + 1 < o[2] ? i((u) => {
              const f = [...u];
              return f[0] = u[0] + 1, f;
            }) : a + 2 < o[0] && o[0] > e.tableShape[0] && i((u) => {
              const f = [...u];
              return f[0] = u[0] - 1, f;
            }), m + 1 === o[1] && m + 1 < o[3] ? i((u) => {
              const f = [...u];
              return f[1] = u[1] + 1, f;
            }) : m + 2 < o[1] && o[1] > e.tableShape[1] && i((u) => {
              const f = [...u];
              return f[1] = u[1] - 1, f;
            });
          },
          onClick: () => {
            e.onSelected(r);
          },
          children: /* @__PURE__ */ d.jsx(
            "div",
            {
              className: [
                `${c}-table-shape-col-default`,
                m <= r.x && a <= r.y && `${c}-table-shape-col-include`
              ].filter((u) => !!u).join(" ")
            }
          )
        },
        `table-shape-col-${a}`
      )) }, `table-shape-row-${m}`))
    }
  );
}, Jn = Qn, Yn = (e) => {
  const { updateSetting: r } = e, { editorId: t } = ne(te), n = F(U.editorExtensions.screenfull.instance), o = F(!1), i = O(
    (l) => {
      if (!n.current) {
        y.emit(t, he, {
          name: "fullscreen",
          message: "fullscreen is undefined"
        });
        return;
      }
      n.current.isEnabled ? (o.current = !o.current, (l === void 0 ? !n.current.isFullscreen : l) ? n.current.request() : n.current.exit()) : console.error("browser does not support screenfull!");
    },
    [t]
  );
  return S(() => {
    const l = () => {
      r("fullscreen", o.current);
    };
    let m = -1;
    if (!n.current) {
      const { editorExtensions: s, editorExtensionsAttrs: a } = U;
      m = requestAnimationFrame(() => {
        var u;
        le(
          "script",
          {
            ...(u = a.screenfull) == null ? void 0 : u.js,
            src: s.screenfull.js,
            id: `${c}-screenfull`,
            onload() {
              n.current = window.screenfull, n.current && n.current.isEnabled && n.current.on("change", l);
            }
          },
          "screenfull"
        );
      });
    }
    return n.current && n.current.isEnabled && n.current.on("change", l), () => {
      n.current || cancelAnimationFrame(m), n.current && n.current.isEnabled && n.current.off("change", l);
    };
  }, [r]), S(() => (y.on(t, {
    name: Ke,
    callback: i
  }), () => {
    y.remove(t, Ke, i);
  }), [t, i]), { fullscreenHandler: i };
}, eo = (e, r) => {
  const { editorId: t } = ne(te), [n, o] = _({
    type: "link",
    linkVisible: !1,
    clipVisible: !1
  }), i = O(() => {
    o((m) => ({
      ...m,
      linkVisible: !1,
      clipVisible: !1
    }));
  }, []), l = O(
    (m) => {
      m && r(n.type, {
        desc: m.desc,
        url: m.url,
        transform: n.type === "image"
      }), i();
    },
    [r, n.type, i]
  );
  return S(() => {
    y.on(t, {
      name: Qe,
      callback(s) {
        o((a) => ({
          ...a,
          type: s,
          linkVisible: !0
        }));
      }
    });
    const m = () => {
      y.emit(
        t,
        je,
        Array.from(e.current.files || [])
      ), e.current.value = "";
    };
    e.current.addEventListener("change", m);
  }, [t, e]), {
    modalData: n,
    setModalData: o,
    onCancel: i,
    onOk: l
  };
}, to = (e) => {
  const [r, t] = _({
    title: !1,
    catalog: !1,
    // 图片上传下拉
    image: !1,
    // 表格预选
    table: !1,
    // mermaid
    mermaid: !1,
    katex: !1
  }), n = O((h) => {
    t((p) => ({
      ...p,
      title: h
    }));
  }, []), o = O(() => {
    t((h) => ({
      ...h,
      title: !1
    }));
  }, []), i = O((h) => {
    t((p) => ({
      ...p,
      image: h
    }));
  }, []), l = O(() => {
    t((h) => ({
      ...h,
      image: !1
    }));
  }, []), m = O((h) => {
    t((p) => ({
      ...p,
      table: h
    }));
  }, []), s = O(
    (h) => {
      e("table", { selectedShape: h });
    },
    [e]
  ), a = O((h) => {
    t((p) => ({
      ...p,
      mermaid: h
    }));
  }, []), u = O(() => {
    t((h) => ({
      ...h,
      mermaid: !1
    }));
  }, []), f = O((h) => {
    t((p) => ({
      ...p,
      katex: h
    }));
  }, []), b = O(() => {
    t((h) => ({
      ...h,
      katex: !1
    }));
  }, []);
  return {
    visible: r,
    onTitleChange: n,
    onTitleClose: o,
    onImageChange: i,
    onImageClose: l,
    onTableChange: m,
    onTableSelected: s,
    onMermaidChange: a,
    onMermaidClose: u,
    onKatexChange: f,
    onKatexClose: b
  };
};
let ro = 0;
const no = (e) => {
  const { toolbars: r, toolbarsExclude: t, updateSetting: n } = e, { editorId: o, usedLanguageText: i, theme: l, previewTheme: m, language: s } = ne(te), a = i, [u] = _(() => `${o}-toolbar-wrapper`), f = F(null), b = F(null), h = O(
    (I, E) => {
      y.emit(o, W, I, E);
    },
    [o]
  ), { fullscreenHandler: p } = Yn(e), { modalData: v, setModalData: g, onCancel: x, onOk: k } = eo(b, h), {
    visible: $,
    onTitleChange: C,
    onTitleClose: T,
    onImageChange: N,
    onImageClose: P,
    onTableChange: L,
    onTableSelected: D,
    onMermaidChange: V,
    onMermaidClose: B,
    onKatexChange: Q,
    onKatexClose: J
  } = to(h), Y = ee(() => {
    var I, E, A, j, z, Z, re, ie;
    return /* @__PURE__ */ d.jsx(
      we,
      {
        relative: `#${u}`,
        visible: $.title,
        onChange: C,
        overlay: /* @__PURE__ */ d.jsxs("ul", { className: `${c}-menu`, onClick: T, children: [
          /* @__PURE__ */ d.jsx(
            "li",
            {
              className: `${c}-menu-item ${c}-menu-item-title`,
              onClick: () => {
                h("h1");
              },
              children: (I = a.titleItem) == null ? void 0 : I.h1
            }
          ),
          /* @__PURE__ */ d.jsx(
            "li",
            {
              className: `${c}-menu-item ${c}-menu-item-title`,
              onClick: () => {
                h("h2");
              },
              children: (E = a.titleItem) == null ? void 0 : E.h2
            }
          ),
          /* @__PURE__ */ d.jsx(
            "li",
            {
              className: `${c}-menu-item ${c}-menu-item-title`,
              onClick: () => {
                h("h3");
              },
              children: (A = a.titleItem) == null ? void 0 : A.h3
            }
          ),
          /* @__PURE__ */ d.jsx(
            "li",
            {
              className: `${c}-menu-item ${c}-menu-item-title`,
              onClick: () => {
                h("h4");
              },
              children: (j = a.titleItem) == null ? void 0 : j.h4
            }
          ),
          /* @__PURE__ */ d.jsx(
            "li",
            {
              className: `${c}-menu-item ${c}-menu-item-title`,
              onClick: () => {
                h("h5");
              },
              children: (z = a.titleItem) == null ? void 0 : z.h5
            }
          ),
          /* @__PURE__ */ d.jsx(
            "li",
            {
              className: `${c}-menu-item ${c}-menu-item-title`,
              onClick: () => {
                h("h6");
              },
              children: (Z = a.titleItem) == null ? void 0 : Z.h6
            }
          )
        ] }, "bar-title-overlay"),
        children: /* @__PURE__ */ d.jsxs(
          "div",
          {
            className: `${c}-toolbar-item`,
            title: (re = a.toolbarTips) == null ? void 0 : re.title,
            children: [
              /* @__PURE__ */ d.jsx(R, { name: "title" }),
              e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (ie = a.toolbarTips) == null ? void 0 : ie.title })
            ]
          },
          "bar-title-trigger"
        )
      },
      "bar-title"
    );
  }, [
    u,
    $.title,
    C,
    T,
    a.titleItem,
    a.toolbarTips,
    e.showToolbarName,
    h
  ]), K = ee(() => {
    var I, E, A, j, z;
    return /* @__PURE__ */ d.jsx(
      we,
      {
        relative: `#${u}`,
        visible: $.image,
        onChange: N,
        overlay: /* @__PURE__ */ d.jsxs("ul", { className: `${c}-menu`, onClick: P, children: [
          /* @__PURE__ */ d.jsx(
            "li",
            {
              className: `${c}-menu-item ${c}-menu-item-image`,
              onClick: () => {
                g((Z) => ({
                  ...Z,
                  type: "image",
                  linkVisible: !0
                }));
              },
              children: (I = a.imgTitleItem) == null ? void 0 : I.link
            }
          ),
          /* @__PURE__ */ d.jsx(
            "li",
            {
              className: `${c}-menu-item ${c}-menu-item-image`,
              onClick: () => {
                b.current.click();
              },
              children: (E = a.imgTitleItem) == null ? void 0 : E.upload
            }
          ),
          /* @__PURE__ */ d.jsx(
            "li",
            {
              className: `${c}-menu-item ${c}-menu-item-image`,
              onClick: () => {
                g((Z) => ({
                  ...Z,
                  type: "image",
                  clipVisible: !0
                }));
              },
              children: (A = a.imgTitleItem) == null ? void 0 : A.clip2upload
            }
          )
        ] }, "bar-image-overlay"),
        children: /* @__PURE__ */ d.jsxs(
          "div",
          {
            className: `${c}-toolbar-item`,
            title: (j = a.toolbarTips) == null ? void 0 : j.image,
            children: [
              /* @__PURE__ */ d.jsx(R, { name: "image" }),
              e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (z = a.toolbarTips) == null ? void 0 : z.image })
            ]
          },
          "bar-image-trigger"
        )
      },
      "bar-image"
    );
  }, [
    u,
    $.image,
    N,
    P,
    a.imgTitleItem,
    a.toolbarTips,
    e.showToolbarName,
    g
  ]), oe = ee(() => {
    var I, E;
    return /* @__PURE__ */ d.jsx(
      we,
      {
        relative: `#${u}`,
        visible: $.table,
        onChange: L,
        overlay: /* @__PURE__ */ d.jsx(
          Jn,
          {
            tableShape: e.tableShape,
            onSelected: D
          },
          "bar-table-overlay"
        ),
        children: /* @__PURE__ */ d.jsxs(
          "div",
          {
            className: `${c}-toolbar-item`,
            title: (I = a.toolbarTips) == null ? void 0 : I.table,
            children: [
              /* @__PURE__ */ d.jsx(R, { name: "table" }),
              e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (E = a.toolbarTips) == null ? void 0 : E.table })
            ]
          },
          "bar-table-trigger"
        )
      },
      "bar-table"
    );
  }, [
    u,
    $.table,
    L,
    e.tableShape,
    e.showToolbarName,
    D,
    a.toolbarTips
  ]), q = ee(() => {
    var I, E, A, j, z, Z, re, ie, ue, ce;
    return /* @__PURE__ */ d.jsx(
      we,
      {
        relative: `#${u}`,
        visible: $.mermaid,
        onChange: V,
        overlay: /* @__PURE__ */ d.jsxs(
          "ul",
          {
            className: `${c}-menu`,
            onClick: B,
            children: [
              /* @__PURE__ */ d.jsx(
                "li",
                {
                  className: `${c}-menu-item ${c}-menu-item-mermaid`,
                  onClick: () => {
                    h("flow");
                  },
                  children: (I = a.mermaid) == null ? void 0 : I.flow
                }
              ),
              /* @__PURE__ */ d.jsx(
                "li",
                {
                  className: `${c}-menu-item ${c}-menu-item-mermaid`,
                  onClick: () => {
                    h("sequence");
                  },
                  children: (E = a.mermaid) == null ? void 0 : E.sequence
                }
              ),
              /* @__PURE__ */ d.jsx(
                "li",
                {
                  className: `${c}-menu-item ${c}-menu-item-mermaid`,
                  onClick: () => {
                    h("gantt");
                  },
                  children: (A = a.mermaid) == null ? void 0 : A.gantt
                }
              ),
              /* @__PURE__ */ d.jsx(
                "li",
                {
                  className: `${c}-menu-item ${c}-menu-item-mermaid`,
                  onClick: () => {
                    h("class");
                  },
                  children: (j = a.mermaid) == null ? void 0 : j.class
                }
              ),
              /* @__PURE__ */ d.jsx(
                "li",
                {
                  className: `${c}-menu-item ${c}-menu-item-mermaid`,
                  onClick: () => {
                    h("state");
                  },
                  children: (z = a.mermaid) == null ? void 0 : z.state
                }
              ),
              /* @__PURE__ */ d.jsx(
                "li",
                {
                  className: `${c}-menu-item ${c}-menu-item-mermaid`,
                  onClick: () => {
                    h("pie");
                  },
                  children: (Z = a.mermaid) == null ? void 0 : Z.pie
                }
              ),
              /* @__PURE__ */ d.jsx(
                "li",
                {
                  className: `${c}-menu-item ${c}-menu-item-mermaid`,
                  onClick: () => {
                    h("relationship");
                  },
                  children: (re = a.mermaid) == null ? void 0 : re.relationship
                }
              ),
              /* @__PURE__ */ d.jsx(
                "li",
                {
                  className: `${c}-menu-item ${c}-menu-item-mermaid`,
                  onClick: () => {
                    h("journey");
                  },
                  children: (ie = a.mermaid) == null ? void 0 : ie.journey
                }
              )
            ]
          },
          "bar-mermaid-overlay"
        ),
        children: /* @__PURE__ */ d.jsxs(
          "div",
          {
            className: `${c}-toolbar-item`,
            title: (ue = a.toolbarTips) == null ? void 0 : ue.mermaid,
            children: [
              /* @__PURE__ */ d.jsx(R, { name: "mermaid" }),
              e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (ce = a.toolbarTips) == null ? void 0 : ce.mermaid })
            ]
          },
          "bar-mermaid-trigger"
        )
      },
      "bar-mermaid"
    );
  }, [
    u,
    $.mermaid,
    V,
    B,
    a.mermaid,
    a.toolbarTips,
    e.showToolbarName,
    h
  ]), M = ee(() => {
    var I, E, A, j;
    return /* @__PURE__ */ d.jsx(
      we,
      {
        relative: `#${u}`,
        visible: $.katex,
        onChange: Q,
        overlay: /* @__PURE__ */ d.jsxs("ul", { className: `${c}-menu`, onClick: J, children: [
          /* @__PURE__ */ d.jsx(
            "li",
            {
              className: `${c}-menu-item ${c}-menu-item-katex`,
              onClick: () => {
                h("katexInline");
              },
              children: (I = a.katex) == null ? void 0 : I.inline
            }
          ),
          /* @__PURE__ */ d.jsx(
            "li",
            {
              className: `${c}-menu-item ${c}-menu-item-katex`,
              onClick: () => {
                h("katexBlock");
              },
              children: (E = a.katex) == null ? void 0 : E.block
            }
          )
        ] }, "bar-katex-overlay"),
        children: /* @__PURE__ */ d.jsxs(
          "div",
          {
            className: `${c}-toolbar-item`,
            title: (A = a.toolbarTips) == null ? void 0 : A.katex,
            children: [
              /* @__PURE__ */ d.jsx(R, { name: "formula" }),
              e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (j = a.toolbarTips) == null ? void 0 : j.katex })
            ]
          },
          "bar-katex-trigger"
        )
      },
      "bar-katex"
    );
  }, [
    u,
    $.katex,
    Q,
    J,
    a.katex,
    a.toolbarTips,
    e.showToolbarName,
    h
  ]), X = O(
    (I) => {
      var E, A, j, z, Z, re, ie, ue, ce, Ae, xe, st, ct, dt, ut, mt, ft, gt, ht, bt, pt, vt, xt, kt, wt, yt, Ct, $t, Tt, St, Nt, jt, At, Et, Lt, It, Ht, Pt, Mt, Dt, Rt, _t, Ft, Ot, Vt, Wt, Bt, zt, Gt, Ut;
      if (jr.includes(I))
        switch (I) {
          case "-":
            return /* @__PURE__ */ d.jsx(Vn, {}, `bar-${ro++}`);
          case "bold":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (E = a.toolbarTips) == null ? void 0 : E.bold,
                onClick: () => {
                  h("bold");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "bold" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (A = a.toolbarTips) == null ? void 0 : A.bold })
                ]
              },
              "bar-bold"
            );
          case "underline":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (j = a.toolbarTips) == null ? void 0 : j.underline,
                onClick: () => {
                  h("underline");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "underline" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (z = a.toolbarTips) == null ? void 0 : z.underline })
                ]
              },
              "bar-underline"
            );
          case "italic":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (Z = a.toolbarTips) == null ? void 0 : Z.italic,
                onClick: () => {
                  h("italic");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "italic" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (re = a.toolbarTips) == null ? void 0 : re.italic })
                ]
              },
              "bar-italic"
            );
          case "strikeThrough":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (ie = a.toolbarTips) == null ? void 0 : ie.strikeThrough,
                onClick: () => {
                  h("strikeThrough");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "strike-through" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (ue = a.toolbarTips) == null ? void 0 : ue.strikeThrough })
                ]
              },
              "bar-strikeThrough"
            );
          case "title":
            return Y;
          case "sub":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (ce = a.toolbarTips) == null ? void 0 : ce.sub,
                onClick: () => {
                  h("sub");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "sub" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (Ae = a.toolbarTips) == null ? void 0 : Ae.sub })
                ]
              },
              "bar-sub"
            );
          case "sup":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (xe = a.toolbarTips) == null ? void 0 : xe.sup,
                onClick: () => {
                  h("sup");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "sup" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (st = a.toolbarTips) == null ? void 0 : st.sup })
                ]
              },
              "bar-sup"
            );
          case "quote":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (ct = a.toolbarTips) == null ? void 0 : ct.quote,
                onClick: () => {
                  h("quote");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "quote" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (dt = a.toolbarTips) == null ? void 0 : dt.quote })
                ]
              },
              "bar-quote"
            );
          case "unorderedList":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (ut = a.toolbarTips) == null ? void 0 : ut.unorderedList,
                onClick: () => {
                  h("unorderedList");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "unordered-list" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (mt = a.toolbarTips) == null ? void 0 : mt.unorderedList })
                ]
              },
              "bar-unorderedList"
            );
          case "orderedList":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (ft = a.toolbarTips) == null ? void 0 : ft.orderedList,
                onClick: () => {
                  h("orderedList");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "ordered-list" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (gt = a.toolbarTips) == null ? void 0 : gt.orderedList })
                ]
              },
              "bar-orderedList"
            );
          case "task":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (ht = a.toolbarTips) == null ? void 0 : ht.task,
                onClick: () => {
                  h("task");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "task" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (bt = a.toolbarTips) == null ? void 0 : bt.task })
                ]
              },
              "bar-task"
            );
          case "codeRow":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (pt = a.toolbarTips) == null ? void 0 : pt.codeRow,
                onClick: () => {
                  h("codeRow");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "code-row" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (vt = a.toolbarTips) == null ? void 0 : vt.codeRow })
                ]
              },
              "bar-codeRow"
            );
          case "code":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (xt = a.toolbarTips) == null ? void 0 : xt.code,
                onClick: () => {
                  h("code");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "code" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (kt = a.toolbarTips) == null ? void 0 : kt.code })
                ]
              },
              "bar-code"
            );
          case "link":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (wt = a.toolbarTips) == null ? void 0 : wt.link,
                onClick: () => {
                  g({
                    ...v,
                    type: "link",
                    linkVisible: !0
                  });
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "link" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (yt = a.toolbarTips) == null ? void 0 : yt.link })
                ]
              },
              "bar-link"
            );
          case "image":
            return e.noUploadImg ? /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (Ct = a.toolbarTips) == null ? void 0 : Ct.image,
                onClick: () => {
                  g((Ee) => ({
                    ...Ee,
                    type: "image",
                    linkVisible: !0
                  }));
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "image" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: ($t = a.toolbarTips) == null ? void 0 : $t.image })
                ]
              },
              "bar-image-no-upload"
            ) : K;
          case "table":
            return oe;
          case "revoke":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (Tt = a.toolbarTips) == null ? void 0 : Tt.revoke,
                onClick: () => {
                  y.emit(o, Ye);
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "revoke" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (St = a.toolbarTips) == null ? void 0 : St.revoke })
                ]
              },
              "bar-revoke"
            );
          case "next":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (Nt = a.toolbarTips) == null ? void 0 : Nt.next,
                onClick: () => {
                  y.emit(o, Je);
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "next" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (jt = a.toolbarTips) == null ? void 0 : jt.next })
                ]
              },
              "bar-next"
            );
          case "save":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (At = a.toolbarTips) == null ? void 0 : At.save,
                onClick: () => {
                  y.emit(o, Ne);
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "baocun" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (Et = a.toolbarTips) == null ? void 0 : Et.save })
                ]
              },
              "bar-save"
            );
          case "prettier":
            return e.noPrettier ? "" : /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (Lt = a.toolbarTips) == null ? void 0 : Lt.prettier,
                onClick: () => {
                  h("prettier");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "prettier" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (It = a.toolbarTips) == null ? void 0 : It.prettier })
                ]
              },
              "bar-prettier"
            );
          case "pageFullscreen":
            return !e.setting.fullscreen && /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (Ht = a.toolbarTips) == null ? void 0 : Ht.pageFullscreen,
                onClick: () => {
                  n("pageFullscreen");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: e.setting.pageFullscreen ? "suoxiao" : "fangda" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (Pt = a.toolbarTips) == null ? void 0 : Pt.pageFullscreen })
                ]
              },
              "bar-pageFullscreen"
            );
          case "fullscreen":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (Mt = a.toolbarTips) == null ? void 0 : Mt.fullscreen,
                onClick: () => {
                  p();
                },
                children: [
                  /* @__PURE__ */ d.jsx(
                    R,
                    {
                      name: e.setting.fullscreen ? "fullscreen-exit" : "fullscreen"
                    }
                  ),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (Dt = a.toolbarTips) == null ? void 0 : Dt.fullscreen })
                ]
              },
              "bar-fullscreen"
            );
          case "catalog":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (Rt = a.toolbarTips) == null ? void 0 : Rt.catalog,
                onClick: () => {
                  y.emit(o, _e);
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "catalog" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (_t = a.toolbarTips) == null ? void 0 : _t.catalog })
                ]
              },
              "bar-catalog"
            );
          case "preview":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (Ft = a.toolbarTips) == null ? void 0 : Ft.preview,
                onClick: () => {
                  n("preview");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "preview" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (Ot = a.toolbarTips) == null ? void 0 : Ot.preview })
                ]
              },
              "bar-preview"
            );
          case "previewOnly":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (Vt = a.toolbarTips) == null ? void 0 : Vt.previewOnly,
                onClick: () => {
                  e.updateSetting("previewOnly");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "preview-only" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (Wt = a.toolbarTips) == null ? void 0 : Wt.previewOnly })
                ]
              },
              "bar-preview-only"
            );
          case "htmlPreview":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (Bt = a.toolbarTips) == null ? void 0 : Bt.htmlPreview,
                onClick: () => {
                  n("htmlPreview");
                },
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "coding" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (zt = a.toolbarTips) == null ? void 0 : zt.htmlPreview })
                ]
              },
              "bar-htmlPreview"
            );
          case "github":
            return /* @__PURE__ */ d.jsxs(
              "div",
              {
                className: `${c}-toolbar-item`,
                title: (Gt = a.toolbarTips) == null ? void 0 : Gt.github,
                onClick: () => rn("https://github.com/imzbf/md-editor-rt"),
                children: [
                  /* @__PURE__ */ d.jsx(R, { name: "github" }),
                  e.showToolbarName && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-item-name`, children: (Ut = a.toolbarTips) == null ? void 0 : Ut.github })
                ]
              },
              "bar-github"
            );
          case "mermaid":
            return q;
          case "katex":
            return M;
        }
      else if (e.defToolbars) {
        const Ee = e.defToolbars[I];
        return Ee ? Sr(Ee, {
          theme: l,
          previewTheme: m,
          language: s,
          insert(Ur) {
            y.emit(o, W, "universal", { generate: Ur });
          }
        }) : "";
      } else
        return "";
    },
    [
      e,
      a.toolbarTips,
      h,
      Y,
      g,
      v,
      K,
      oe,
      o,
      n,
      p,
      q,
      M,
      l,
      s,
      m
    ]
  ), ae = ee(() => {
    const I = r.filter((z) => !t.includes(z)), E = I.indexOf("="), A = E === -1 ? I : I.slice(0, E + 1), j = E === -1 ? [] : I.slice(E, Number.MAX_SAFE_INTEGER);
    return [
      A.map((z) => X(z)),
      j.map((z) => X(z))
    ];
  }, [r, t, X]);
  return S(() => {
    let I = () => {
    };
    return f.current && (I = nn(f.current)), () => {
      I();
    };
  }, [r]), /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    r.length > 0 && /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-wrapper`, ref: f, id: u, children: /* @__PURE__ */ d.jsxs(
      "div",
      {
        className: Ve([
          `${c}-toolbar`,
          e.showToolbarName && `${c}-stn`
        ]),
        children: [
          /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-left`, children: ae[0] }),
          /* @__PURE__ */ d.jsx("div", { className: `${c}-toolbar-right`, children: ae[1] })
        ]
      }
    ) }),
    /* @__PURE__ */ d.jsx(
      "input",
      {
        ref: b,
        accept: "image/*",
        type: "file",
        multiple: !0,
        style: { display: "none" }
      }
    ),
    /* @__PURE__ */ d.jsx(
      Zn,
      {
        linkVisible: v.linkVisible,
        clipVisible: v.clipVisible,
        type: v.type,
        onCancel: x,
        onOk: k
      }
    )
  ] });
}, oo = ot.memo(no), ao = `.${c}-preview > [data-line]`, Ie = (e, r) => +getComputedStyle(e).getPropertyValue(r).replace("px", ""), io = (e, r) => {
  const t = on(() => {
    e.removeEventListener("scroll", n), e.addEventListener("scroll", n), r.removeEventListener("scroll", n), r.addEventListener("scroll", n);
  }, 50), n = (o) => {
    const i = e.clientHeight, l = r.clientHeight, m = e.scrollHeight, s = r.scrollHeight, a = (m - i) / (s - l);
    o.target === e ? (r.removeEventListener("scroll", n), r.scrollTo({
      top: e.scrollTop / a
      // behavior: 'smooth'
    }), t()) : (e.removeEventListener("scroll", n), e.scrollTo({
      top: r.scrollTop * a
      // behavior: 'smooth'
    }), t());
  };
  return [
    () => {
      t().finally(() => {
        e.dispatchEvent(new Event("scroll"));
      });
    },
    () => {
      e.removeEventListener("scroll", n), r.removeEventListener("scroll", n);
    }
  ];
}, lo = (e, r, t) => {
  const { view: n } = t, o = an(), i = (x) => n.lineBlockAt(n.state.doc.line(x + 1).from).top, l = (x) => n.lineBlockAt(n.state.doc.line(x + 1).from).bottom;
  let m = [], s = [], a = [];
  const u = () => {
    m = [], s = Array.from(
      r.querySelectorAll(ao)
    ), a = s.map((T) => Number(T.dataset.line));
    const x = [...a], { lines: k } = n.state.doc;
    let $ = x.shift() || 0, C = x.shift() || k;
    for (let T = 0; T < k; T++)
      T === C && ($ = T, C = x.shift() || k), m.push({
        start: $,
        end: C - 1
      });
  }, f = (x, k) => {
    let $ = 1;
    for (let C = s.length - 1; C - 1 >= 0; C--) {
      const T = s[C], N = s[C - 1];
      if (T.offsetTop + T.offsetHeight > k && N.offsetTop < k) {
        $ = Number(N.dataset.line);
        break;
      }
    }
    for (let C = m.length - 1; C >= 0; C--) {
      const T = l(m[C].end), N = i(m[C].start);
      if (T > x && N <= x) {
        $ = $ < m[C].start ? $ : m[C].start;
        break;
      }
    }
    return $;
  };
  let b = 0, h = 0;
  const p = () => {
    var M, X, ae;
    if (h !== 0)
      return !1;
    b++;
    const { scrollDOM: x, contentHeight: k } = n;
    let $ = Ie(r, "padding-top");
    const C = n.lineBlockAtHeight(x.scrollTop), { number: T } = n.state.doc.lineAt(C.from), N = m[T - 1];
    if (!N)
      return !1;
    let P = 1;
    const L = r.querySelector(`[data-line="${N.start}"]`) || ((M = r.firstElementChild) == null ? void 0 : M.firstElementChild), D = r.querySelector(`[data-line="${N.end + 1}"]`) || ((X = r.lastElementChild) == null ? void 0 : X.lastElementChild), V = x.scrollHeight - x.clientHeight, B = r.scrollHeight - r.clientHeight;
    let Q = i(N.start), J = l(N.end), Y = L.offsetTop, K = D.offsetTop - Y;
    Q === 0 && (Y = 0, L === D ? ($ = 0, J = k - x.offsetHeight, K = B) : K = D.offsetTop), P = (x.scrollTop - Q) / (J - Q);
    const oe = D == ((ae = r.lastElementChild) == null ? void 0 : ae.lastElementChild) ? D.offsetTop + D.clientHeight : D.offsetTop;
    if (J >= V || oe > B) {
      const I = f(V, B);
      Q = i(I), P = (x.scrollTop - Q) / (V - Q);
      const E = document.querySelector(`[data-line="${I}"]`);
      Q > 0 && E && (Y = E.offsetTop), K = B - Y + Ie(r, "padding-top");
    }
    const q = Y - $ + K * P;
    o(r, q, () => {
      b--;
    });
  }, v = () => {
    var oe, q, M, X, ae, I;
    if (b !== 0)
      return;
    h++;
    const { scrollDOM: x } = n, k = r.scrollTop, $ = r.scrollHeight, C = x.scrollHeight - x.clientHeight, T = r.scrollHeight - r.clientHeight;
    let N = (oe = r.firstElementChild) == null ? void 0 : oe.firstElementChild, P = (q = r.firstElementChild) == null ? void 0 : q.lastElementChild;
    if (a.length > 0) {
      let E = Math.ceil(
        a[a.length - 1] * (k / $)
      ), A = a.findLastIndex((j) => j <= E);
      A = A === -1 ? 0 : A, E = a[A];
      for (let j = A; j >= 0 && j < a.length; )
        if (s[j].offsetTop > k) {
          if (j - 1 >= 0) {
            j--;
            continue;
          }
          E = -1, A = j;
          break;
        } else {
          if (j + 1 < a.length && s[j + 1].offsetTop < k) {
            j++;
            continue;
          }
          E = a[j], A = j;
          break;
        }
      switch (A) {
        case -1: {
          N = (M = r.firstElementChild) == null ? void 0 : M.firstElementChild, P = s[A];
          break;
        }
        case a.length - 1: {
          N = s[A], P = (X = r.firstElementChild) == null ? void 0 : X.lastElementChild;
          break;
        }
        default:
          N = s[A], P = s[A + 1 === s.length ? A : A + 1];
      }
    }
    let L = N === ((ae = r.firstElementChild) == null ? void 0 : ae.firstElementChild) ? 0 : N.offsetTop - Ie(N, "margin-top"), D = P.offsetTop, V = 0;
    const { start: B, end: Q } = m[Number(N.dataset.line || 0)];
    let J = i(B);
    const Y = i(
      Q + 1 === n.state.doc.lines ? Q : Q + 1
    );
    let K = 0;
    if (Y > C || P.offsetTop + P.offsetHeight > T) {
      const E = f(C, T), A = document.querySelector(`[data-line="${E}"]`);
      L = A ? A.offsetTop - Ie(A, "margin-top") : L, J = i(E), V = (k - L) / (T - L), K = C - J;
    } else
      N === ((I = r.firstElementChild) == null ? void 0 : I.firstElementChild) ? (N === P && (D = P.offsetTop + P.offsetHeight + +getComputedStyle(P).marginBottom.replace("px", "")), K = Y, V = Math.max(k / D, 0)) : (V = Math.max(
        (k - L) / (D - L),
        0
      ), K = Y - J);
    o(e, J + K * V, () => {
      h--;
    });
  }, g = (x) => {
    var T;
    const { scrollDOM: k, contentHeight: $ } = n, C = k.clientHeight;
    if ($ <= C || r.firstElementChild.clientHeight <= r.clientHeight || n.state.doc.lines <= ((T = m[m.length - 1]) == null ? void 0 : T.end))
      return !1;
    x.target === e ? p() : v();
  };
  return [
    () => {
      u(), e.addEventListener("scroll", g), r.addEventListener("scroll", g), e.dispatchEvent(new Event("scroll"));
    },
    () => {
      e.removeEventListener("scroll", g), r.removeEventListener("scroll", g);
    }
  ];
}, so = (e, r, t) => {
  const { editorId: n } = ne(te), [o, i] = _({
    clear() {
    },
    init() {
    }
  });
  S(() => {
    const l = document.querySelector(
      `#${n} .cm-scroller`
    ), m = document.querySelector(
      `[id="${n}-preview-wrapper"]`
    ), s = document.querySelector(
      `[id="${n}-html-wrapper"]`
    );
    if (m || s) {
      const a = m ? lo : io, u = m || s, [f, b] = a(l, u, t.current);
      i({
        init: f,
        clear: b
      });
    }
  }, [
    r,
    e.setting.fullscreen,
    e.setting.pageFullscreen,
    e.setting.preview,
    e.setting.htmlPreview,
    n,
    t
  ]), S(() => (e.scrollAuto && !e.setting.previewOnly && (e.setting.preview || e.setting.htmlPreview) ? o.init() : o.clear(), () => {
    o.clear();
  }), [
    o,
    e.scrollAuto,
    e.setting.preview,
    e.setting.htmlPreview,
    e.setting.previewOnly
  ]);
}, Ge = (e, r, t) => {
  var u;
  let n = "", o = 0, i = 0, l = !0, m = !1;
  const s = r.getSelectedText(), a = U.editorConfig.mermaidTemplate;
  if (/^h[1-6]{1}$/.test(e)) {
    const f = e.replace(/^h(\d)/, (b, h) => new Array(Number(h)).fill("#", 0, h).join(""));
    n = `${f} ${s}`, o = f.length + 1;
  } else if (e === "prettier") {
    const f = window.prettier || U.editorExtensions.prettier.prettierInstance, b = [
      ((u = window.prettierPlugins) == null ? void 0 : u.markdown) || U.editorExtensions.prettier.parserMarkdownInstance
    ];
    !f || b[0] === void 0 ? (y.emit(t.editorId, he, {
      name: "prettier",
      message: "prettier is undefined"
    }), n = r.getValue()) : n = f.format(r.getValue(), {
      parser: "markdown",
      plugins: b
    }), l = !1, m = !0;
  } else
    switch (e) {
      case "bold": {
        n = `**${s}**`, o = 2, i = -2;
        break;
      }
      case "underline": {
        n = `<u>${s}</u>`, o = 3, i = -4;
        break;
      }
      case "italic": {
        n = `*${s}*`, o = 1, i = -1;
        break;
      }
      case "strikeThrough": {
        n = `~~${s}~~`, o = 2, i = -2;
        break;
      }
      case "sub": {
        n = `<sub>${s}</sub>`, o = 5, i = -6;
        break;
      }
      case "sup": {
        n = `<sup>${s}</sup>`, o = 5, i = -6;
        break;
      }
      case "codeRow": {
        n = "`" + s + "`", o = 1, i = -1;
        break;
      }
      case "quote": {
        n = `> ${s}`, o = 2;
        break;
      }
      case "orderedList": {
        n = `1. ${s}`, o = 3;
        break;
      }
      case "unorderedList": {
        n = `- ${s}`, o = 2;
        break;
      }
      case "task": {
        n = `- [ ] ${s}`, o = 6;
        break;
      }
      case "code": {
        const f = t.text || s || "", b = t.mode || "language";
        n = `\`\`\`${b}
${f}
\`\`\`
`, o = 3, i = 3 + b.length - n.length;
        break;
      }
      case "table": {
        n = "|";
        const { selectedShape: f = { x: 1, y: 1 } } = t, { x: b, y: h } = f;
        for (let p = 0; p <= h; p++)
          n += " col |";
        n += `
|`;
        for (let p = 0; p <= h; p++)
          n += " - |";
        for (let p = 0; p <= b; p++) {
          n += `
|`;
          for (let v = 0; v <= h; v++)
            n += " content |";
        }
        o = 2, i = 5 - n.length;
        break;
      }
      case "link": {
        const { desc: f, url: b } = t;
        n = `[${f}](${b})`, l = !1;
        break;
      }
      case "image": {
        const { desc: f, url: b, urls: h } = t;
        h instanceof Array ? n = h.reduce((p, v) => {
          const {
            url: g = "",
            alt: x = "",
            title: k = ""
          } = typeof v == "object" ? v : { url: v };
          return p + `![${x}](${g}${k ? " '" + k + "'" : ""})
`;
        }, "") : n = `![${f}](${b})
`, l = !1;
        break;
      }
      case "flow": {
        n = `\`\`\`mermaid
${(a == null ? void 0 : a.flow) || `flowchart TD 
  Start --> Stop`}
\`\`\`
`, o = 3, i = 10 - n.length;
        break;
      }
      case "sequence": {
        n = `\`\`\`mermaid
${(a == null ? void 0 : a.sequence) || `sequenceDiagram
  A->>B: hello!
  B-->>A: hi!
  A-)B: bye!`}
\`\`\`
`, o = 3, i = 10 - n.length;
        break;
      }
      case "gantt": {
        n = `\`\`\`mermaid
${(a == null ? void 0 : a.gantt) || `gantt
title A Gantt Diagram
dateFormat  YYYY-MM-DD
section Section
A task  :a1, 2014-01-01, 30d
Another task  :after a1, 20d`}
\`\`\`
`, o = 3, i = 10 - n.length;
        break;
      }
      case "class": {
        n = `\`\`\`mermaid
${(a == null ? void 0 : a.class) || `classDiagram
  class Animal
  Vehicle <|-- Car`}
\`\`\`
`, o = 3, i = 10 - n.length;
        break;
      }
      case "state": {
        n = `\`\`\`mermaid
${(a == null ? void 0 : a.state) || `stateDiagram-v2
  s1 --> s2`}
\`\`\`
`, o = 3, i = 10 - n.length;
        break;
      }
      case "pie": {
        n = `\`\`\`mermaid
${(a == null ? void 0 : a.pie) || `pie title Pets adopted by volunteers
  "Dogs" : 386
  "Cats" : 85
  "Rats" : 15`}
\`\`\`
`, o = 3, i = 10 - n.length;
        break;
      }
      case "relationship": {
        n = `\`\`\`mermaid
${(a == null ? void 0 : a.relationship) || `erDiagram
  CAR ||--o{ NAMED-DRIVER : allows
  PERSON ||--o{ NAMED-DRIVER : is`}
\`\`\`
`, o = 3, i = 10 - n.length;
        break;
      }
      case "journey": {
        n = `\`\`\`mermaid
${(a == null ? void 0 : a.journey) || `journey
  title My working day
  section Go to work
    Make tea: 5: Me
    Go upstairs: 3: Me
    Do work: 1: Me, Cat
  section Go home
    Go downstairs: 5: Me
    Sit down: 5: Me`}
\`\`\`
`, o = 3, i = 10 - n.length;
        break;
      }
      case "katexInline": {
        n = "$$", o = 1, i = -1;
        break;
      }
      case "katexBlock": {
        n = `$$

$$
`, o = 3, i = -4;
        break;
      }
      case "universal": {
        const { generate: f } = t, b = f(s);
        n = b.targetValue, l = b.select ?? !0, o = b.deviationStart || 0, i = b.deviationEnd || 0;
      }
    }
  return {
    text: n,
    options: {
      // 是否选中
      select: l,
      // 选中时，开始位置的偏移量
      deviationStart: o,
      // 结束的偏移量
      deviationEnd: i,
      // 是否整个替换
      replaceAll: m
    }
  };
}, ke = (e) => {
  const r = new pe();
  return (n) => (r.get(e.state) ? e.dispatch({ effects: r.reconfigure(n) }) : e.dispatch({
    effects: un.appendConfig.of(r.of(n))
  }), !0);
};
class co {
  constructor(r) {
    me(this, "view");
    me(this, "maxLength", Number.MAX_SAFE_INTEGER);
    // 切换tabSize的执行方法。切换时，Compartment实例需要相同
    me(this, "toggleTabSize");
    me(this, "togglePlaceholder");
    /**
     * 设置全部的扩展
     */
    me(this, "setExtensions");
    me(this, "toggleDisabled");
    me(this, "toggleReadOnly");
    me(this, "toggleMaxlength");
    this.view = r, this.toggleTabSize = ke(this.view), this.togglePlaceholder = ke(this.view), this.setExtensions = ke(this.view), this.toggleDisabled = ke(this.view), this.toggleReadOnly = ke(this.view), this.toggleMaxlength = ke(this.view);
  }
  getValue() {
    return this.view.state.doc.toString();
  }
  /**
   * 设置内容
   *
   * @param insert 待插入内容
   * @param from 插入开始位置
   * @param to 插入结束位置
   */
  setValue(r, t = 0, n = this.view.state.doc.length) {
    this.view.dispatch({
      changes: {
        from: t,
        to: n,
        insert: r
      }
    });
  }
  /**
   * 获取选中的文本
   */
  getSelectedText() {
    const { from: r, to: t } = this.view.state.selection.main;
    return this.view.state.sliceDoc(r, t);
  }
  /**
   * 使用新的内容替换选中的内容
   *
   * @param text 待替换内容
   * @param options 替换后是否选中
   */
  replaceSelectedText(r, t = {
    // 是否选中
    select: !0,
    // 选中时，开始位置的偏移量
    deviationStart: 0,
    // 结束的偏移量
    deviationEnd: 0,
    // 直接替换所有文本
    replaceAll: !1
  }, n) {
    try {
      if (t.replaceAll) {
        if (this.setValue(r), r.length > this.maxLength)
          throw new Error("The input text is too long");
        return;
      }
      if (this.view.state.doc.length - this.getSelectedText().length + r.length > this.maxLength)
        throw new Error("The input text is too long");
      const { from: o } = this.view.state.selection.main;
      if (this.view.dispatch(this.view.state.replaceSelection(r)), t.select) {
        const i = o + r.length + t.deviationEnd;
        this.view.dispatch({
          selection: fe.create(
            [
              fe.range(o + t.deviationStart, i),
              fe.cursor(i)
            ],
            1
          )
        });
      }
      this.view.focus();
    } catch (o) {
      if (o.message === "The input text is too long")
        y.emit(n, he, {
          name: "overlength",
          message: o.message,
          data: r
        });
      else
        throw o;
    }
  }
  /**
   * 设置tabSize
   *
   * @param tabSize 需要切换的大小
   */
  setTabSize(r) {
    this.toggleTabSize([
      ze.tabSize.of(r),
      vn.of(" ".repeat(r))
    ]);
  }
  /**
   * 设置placeholder
   *
   * @param t 目标内容
   */
  setPlaceholder(r) {
    this.togglePlaceholder(ln(r));
  }
  focus(r) {
    if (this.view.focus(), !r)
      return;
    let t = 0, n = 0, o = 0;
    switch (r) {
      case "start":
        break;
      case "end": {
        t = n = o = this.getValue().length;
        break;
      }
      default:
        t = r.rangeAnchor || r.cursorPos, n = r.rangeHead || r.cursorPos, o = r.cursorPos;
    }
    this.view.dispatch({
      scrollIntoView: !0,
      selection: fe.create(
        [fe.range(t, n), fe.cursor(o)],
        1
      )
    });
  }
  setDisabled(r) {
    this.toggleDisabled([at.editable.of(!r)]);
  }
  setReadOnly(r) {
    this.toggleReadOnly([ze.readOnly.of(r)]);
  }
  setMaxLength(r) {
    this.maxLength = r, this.toggleMaxlength([
      ze.changeFilter.of((t) => t.newDoc.length <= r)
    ]);
  }
}
const uo = "#e5c07b", ar = "var(--md-color)", mo = "#56b6c2", fo = "#ffffff", $e = "var(--md-color)", ir = "#e5c07b", go = "#e5c07b", ho = "var(--md-color)", lr = "#d19a66", bo = "#c678dd", po = "#21252b", vo = "#2c313a", sr = "var(--md-bk-color)", Ue = "var(--md-bk-color)", xo = "#ceedfa33", cr = "#528bff", ko = at.theme(
  {
    "&": {
      color: $e,
      backgroundColor: sr
    },
    ".cm-content": {
      caretColor: cr
    },
    ".cm-cursor, .cm-dropCursor": { borderLeftColor: cr },
    "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": { backgroundColor: xo },
    ".cm-panels": { backgroundColor: po, color: $e },
    ".cm-panels.cm-panels-top": { borderBottom: "1px solid var(--md-border-color)" },
    ".cm-panels.cm-panels-bottom": { borderTop: "1px solid var(--md-border-color)" },
    ".cm-searchMatch": {
      backgroundColor: "#72a1ff59",
      outline: "1px solid #457dff"
    },
    ".cm-searchMatch.cm-searchMatch-selected": {
      backgroundColor: "#6199ff2f"
    },
    ".cm-activeLine": { backgroundColor: "#ceedfa33" },
    ".cm-selectionMatch": { backgroundColor: "#aafe661a" },
    "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
      backgroundColor: "#bad0f847"
    },
    ".cm-gutters": {
      backgroundColor: sr,
      color: $e,
      borderRight: "1px solid",
      borderColor: "var(--md-border-color)"
    },
    ".cm-activeLineGutter": {
      backgroundColor: vo
    },
    ".cm-foldPlaceholder": {
      backgroundColor: "transparent",
      border: "none",
      color: "#ddd"
    },
    ".cm-tooltip": {
      border: "1px solid var(--md-border-color)",
      backgroundColor: Ue
    },
    ".cm-tooltip .cm-tooltip-arrow:before": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    },
    ".cm-tooltip .cm-tooltip-arrow:after": {
      borderTopColor: Ue,
      borderBottomColor: Ue
    },
    ".cm-tooltip-autocomplete": {
      "& > ul > li[aria-selected]": {
        color: $e
      }
    }
  },
  { dark: !0 }
), wo = Ar.define([
  { tag: w.keyword, color: bo },
  { tag: [w.name, w.deleted, w.character, w.propertyName, w.macroName], color: ar },
  { tag: [w.function(w.variableName), w.labelName], color: go },
  { tag: [w.color, w.constant(w.name), w.standard(w.name)], color: lr },
  { tag: [w.definition(w.name), w.separator], color: $e },
  {
    tag: [
      w.typeName,
      w.className,
      w.number,
      w.changed,
      w.annotation,
      w.modifier,
      w.self,
      w.namespace
    ],
    color: uo
  },
  {
    tag: [
      w.operator,
      w.operatorKeyword,
      w.url,
      w.escape,
      w.regexp,
      w.link,
      w.special(w.string)
    ],
    color: mo
  },
  { tag: [w.meta, w.comment], color: ir },
  { tag: w.strong, fontWeight: "bold" },
  { tag: w.emphasis, fontStyle: "italic" },
  { tag: w.strikethrough, textDecoration: "line-through" },
  { tag: w.link, color: ir, textDecoration: "underline" },
  { tag: w.heading, fontWeight: "bold", color: ar },
  { tag: [w.atom, w.bool, w.special(w.variableName)], color: lr },
  { tag: [w.processingInstruction, w.string, w.inserted], color: ho },
  { tag: w.invalid, color: fo }
]), dr = [
  ko,
  Er(wo)
], yo = "#e5c07b", ur = "#3f4a54", Co = "#56b6c2", $o = "#fff", Te = "#3f4a54", mr = "#2d8cf0", To = "#2d8cf0", So = "#3f4a54", fr = "#d19a66", No = "#c678dd", jo = "#f6f6f6", Ao = "#ceedfa33", gr = "var(--md-bk-color)", qe = "var(--md-bk-color)", Eo = "#bad5fa", hr = "#3f4a54", Lo = at.theme(
  {
    "&": {
      color: Te,
      backgroundColor: gr
    },
    ".cm-content": {
      caretColor: hr
    },
    ".cm-cursor, .cm-dropCursor": { borderLeftColor: hr },
    "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": { backgroundColor: Eo },
    ".cm-panels": { backgroundColor: jo, color: Te },
    ".cm-panels.cm-panels-top": { borderBottom: "1px solid var(--md-border-color)" },
    ".cm-panels.cm-panels-bottom": { borderTop: "1px solid var(--md-border-color)" },
    ".cm-searchMatch": {
      backgroundColor: "#72a1ff59",
      outline: "1px solid #457dff"
    },
    ".cm-searchMatch.cm-searchMatch-selected": {
      backgroundColor: "#6199ff2f"
    },
    ".cm-activeLine": { backgroundColor: "#ceedfa33" },
    ".cm-selectionMatch": { backgroundColor: "#aafe661a" },
    "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
      backgroundColor: "#bad0f847"
    },
    ".cm-gutters": {
      backgroundColor: gr,
      color: Te,
      borderRight: "1px solid",
      borderColor: "var(--md-border-color)"
    },
    ".cm-activeLineGutter": {
      backgroundColor: Ao
    },
    ".cm-foldPlaceholder": {
      backgroundColor: "transparent",
      border: "none",
      color: "#ddd"
    },
    ".cm-tooltip": {
      border: "1px solid var(--md-border-color)",
      backgroundColor: qe
    },
    ".cm-tooltip .cm-tooltip-arrow:before": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    },
    ".cm-tooltip .cm-tooltip-arrow:after": {
      borderTopColor: qe,
      borderBottomColor: qe
    },
    ".cm-tooltip-autocomplete": {
      "& > ul > li[aria-selected]": {
        color: Te
      }
    }
  }
  // { dark: true }
), Io = Ar.define([
  { tag: w.keyword, color: No },
  { tag: [w.name, w.deleted, w.character, w.propertyName, w.macroName], color: ur },
  { tag: [w.function(w.variableName), w.labelName], color: To },
  { tag: [w.color, w.constant(w.name), w.standard(w.name)], color: fr },
  { tag: [w.definition(w.name), w.separator], color: Te },
  {
    tag: [
      w.typeName,
      w.className,
      w.number,
      w.changed,
      w.annotation,
      w.modifier,
      w.self,
      w.namespace
    ],
    color: yo
  },
  {
    tag: [
      w.operator,
      w.operatorKeyword,
      w.url,
      w.escape,
      w.regexp,
      w.link,
      w.special(w.string)
    ],
    color: Co
  },
  { tag: [w.meta, w.comment], color: mr },
  { tag: w.strong, fontWeight: "bold" },
  { tag: w.emphasis, fontStyle: "italic" },
  { tag: w.strikethrough, textDecoration: "line-through" },
  { tag: w.link, color: mr, textDecoration: "underline" },
  { tag: w.heading, fontWeight: "bold", color: ur },
  { tag: [w.atom, w.bool, w.special(w.variableName)], color: fr },
  { tag: [w.processingInstruction, w.string, w.inserted], color: So },
  { tag: w.invalid, color: $o }
]), br = [
  Lo,
  Er(Io)
], He = (e, r, t, n, o) => (i, l, m, s) => {
  const a = `${e}${r}`.slice(s - m);
  i.dispatch(i.state.replaceSelection(`${a}${t}${n}`));
  const u = m + l.label.length + (o === "title" ? t.length : 0);
  i.dispatch({
    selection: fe.create(
      [
        fe.range(
          m + l.label.length + (o === "title" ? 1 : -r.length),
          u
        ),
        fe.cursor(u)
      ],
      1
    )
  }), i.focus();
}, pr = (e) => (r, t, n, o) => {
  const i = e.slice(o - n);
  r.dispatch(r.state.replaceSelection(`${i} `));
}, vr = (e) => {
  const r = (t) => {
    const n = t.matchBefore(
      /^#+|^-\s*\[*\s*\]*|`+|\[|!\[*|^\|\s?\|?|\$\$?|!+\s*\w*/
    );
    return n === null || n.from == n.to && t.explicit ? null : {
      from: n.from,
      options: [
        // 标题
        ...["h1", "h2", "h3", "h4", "h5", "h6"].map((o, i) => {
          const l = new Array(i + 1).fill("#").join("");
          return {
            label: l,
            type: "text",
            apply: pr(l)
          };
        }),
        // 任务列表
        ...["unchecked", "checked"].map((o) => {
          const i = o === "checked" ? "- [x]" : "- [ ]";
          return {
            label: i,
            type: "text",
            apply: pr(i)
          };
        }),
        // 代码
        ...[
          ["`", ""],
          ["```", "language"],
          ["```mermaid\n", ""]
        ].map((o) => ({
          label: `${o[0]}${o[1]}`,
          type: "text",
          apply: He(o[0], o[1], "", o[0] === "`" ? "`" : "\n```", "type")
        })),
        // 链接
        {
          label: "[]()",
          type: "text"
        },
        {
          label: "![]()",
          type: "text"
        },
        // 表格
        {
          label: "| |",
          type: "text",
          detail: "table",
          apply: `| col | col | col |
| - | - | - |
| content | content | content |
| content | content | content |`
        },
        // 公式
        {
          label: "$",
          type: "text",
          apply: He("$", "", "", "$", "type")
        },
        {
          label: "$$",
          type: "text",
          apply: He("$$", "", `
`, `
$$`, "title")
        },
        // 那啥？
        ...[
          "note",
          "abstract",
          "info",
          "tip",
          "success",
          "question",
          "warning",
          "failure",
          "danger",
          "bug",
          "example",
          "quote",
          "hint",
          "caution",
          "error",
          "attention"
        ].map((o) => ({
          label: `!!! ${o}`,
          type: "text",
          apply: He("!!!", ` ${o}`, " Title", `

!!!`, "title")
        }))
      ]
    };
  };
  return xn({
    override: e ? [r, ...e] : [r]
  });
}, Ho = (e, r) => [
  {
    key: "Ctrl-b",
    mac: "Cmd-b",
    run: () => (y.emit(e, W, "bold"), !0)
  },
  {
    key: "Ctrl-d",
    mac: "Cmd-d",
    run: mn,
    preventDefault: !0
  },
  {
    key: "Ctrl-s",
    mac: "Cmd-s",
    run: (C) => (y.emit(e, Ne, C.state.doc.toString()), !0),
    shift: () => (y.emit(e, W, "strikeThrough"), !0)
  },
  {
    key: "Ctrl-u",
    mac: "Cmd-u",
    run: () => (y.emit(e, W, "underline"), !0),
    shift: () => (y.emit(e, W, "unorderedList"), !0)
  },
  {
    key: "Ctrl-i",
    mac: "Cmd-i",
    run: () => (y.emit(e, W, "italic"), !0),
    shift: () => (y.emit(e, Qe, "image"), !0)
  },
  {
    key: "Ctrl-1",
    mac: "Cmd-1",
    run: () => (y.emit(e, W, "h1"), !0)
  },
  {
    key: "Ctrl-2",
    mac: "Cmd-2",
    run: () => (y.emit(e, W, "h2"), !0)
  },
  {
    key: "Ctrl-3",
    mac: "Cmd-3",
    run: () => (y.emit(e, W, "h3"), !0)
  },
  {
    key: "Ctrl-4",
    mac: "Cmd-4",
    run: () => (y.emit(e, W, "h4"), !0)
  },
  {
    key: "Ctrl-5",
    mac: "Cmd-5",
    run: () => (y.emit(e, W, "h5"), !0)
  },
  {
    key: "Ctrl-6",
    mac: "Cmd-6",
    run: () => (y.emit(e, W, "h6"), !0)
  },
  {
    key: "Ctrl-ArrowUp",
    mac: "Cmd-ArrowUp",
    run: () => (y.emit(e, W, "sup"), !0)
  },
  {
    key: "Ctrl-ArrowDown",
    mac: "Cmd-ArrowDown",
    run: () => (y.emit(e, W, "sub"), !0)
  },
  {
    key: "Ctrl-o",
    mac: "Cmd-o",
    run: () => (y.emit(e, W, "orderedList"), !0)
  },
  {
    key: "Ctrl-c",
    mac: "Cmd-c",
    shift: () => (y.emit(e, W, "code"), !0),
    any(C, T) {
      return (T.ctrlKey || T.metaKey) && T.altKey && T.code === "KeyC" ? (y.emit(e, W, "codeRow"), !0) : !1;
    }
  },
  {
    key: "Ctrl-l",
    mac: "Cmd-l",
    run: () => (y.emit(e, Qe, "link"), !0)
  },
  {
    key: "Ctrl-f",
    mac: "Cmd-f",
    shift: () => r.noPrettier ? !1 : (y.emit(e, W, "prettier"), !0)
  },
  {
    any: (C, T) => (T.ctrlKey || T.metaKey) && T.altKey && T.shiftKey && T.code === "KeyT" ? (y.emit(e, W, "table"), !0) : !1
  },
  ...kn
], Po = (e, r) => {
  const { editorId: t } = ne(te), n = O(
    (i) => {
      i instanceof Promise ? i.then((l) => {
        y.emit(t, W, "universal", {
          generate() {
            return {
              targetValue: l
            };
          }
        });
      }).catch((l) => {
        console.error(l);
      }) : y.emit(t, W, "universal", {
        generate() {
          return {
            targetValue: i
          };
        }
      });
    },
    [t]
  );
  return O(
    (i) => {
      var b, h, p;
      if (!i.clipboardData)
        return;
      if (i.clipboardData.files.length > 0) {
        const { files: v } = i.clipboardData;
        y.emit(
          t,
          je,
          Array.from(v).filter((g) => /image\/.*/.test(g.type))
        ), i.preventDefault();
        return;
      }
      const l = i.clipboardData.getData("text/plain"), m = ((b = r.current) == null ? void 0 : b.view.state.selection.main.to) || 0, s = ((h = r.current) == null ? void 0 : h.view.state.doc.lineAt(m).from) || 0, a = ((p = r.current) == null ? void 0 : p.view.state.doc.sliceString(s, m)) || "", u = /!\[.*\]\(\s*$/.test(a), f = /!\[.*\]\((.*)\s?.*\)/.test(l);
      if (u) {
        const v = e.transformImgUrl(l);
        n(v), i.preventDefault();
        return;
      } else if (f) {
        const v = l.match(
          new RegExp(`(?<=!\\[.*\\]\\()([^)\\s]+)(?=\\s?["']?.*["']?\\))`, "g")
        );
        v ? Promise.all(
          v.map((g) => e.transformImgUrl(g))
        ).then((g) => {
          n(
            g.reduce((x, k, $) => x.replace(v[$], k), l)
          );
        }) : n(l), i.preventDefault();
        return;
      }
      if (e.autoDetectCode && i.clipboardData.types.includes("vscode-editor-data")) {
        const v = JSON.parse(i.clipboardData.getData("vscode-editor-data"));
        y.emit(t, W, "code", {
          mode: v.mode,
          text: i.clipboardData.getData("text/plain")
        }), i.preventDefault();
        return;
      }
      e.maxLength && l.length + e.modelValue.length > e.maxLength && y.emit(t, he, {
        name: "overlength",
        message: "The input text is too long",
        data: l
      });
    },
    [r, t, n, e]
  );
};
be.EDIT_CONTEXT = !1;
const Mo = (e) => {
  const { tabWidth: r, editorId: t, theme: n } = ne(te), o = F(null), i = F(), [l] = _(() => ({
    language: new pe(),
    theme: new pe(),
    autocompletion: new pe(),
    update: new pe(),
    domEvent: new pe(),
    history: new pe()
  })), [m] = _(() => Ho(t, e)), s = F(!0), a = Po(e, i), [u, f] = _({}), b = ee(() => {
    const g = {
      paste: a,
      blur: e.onBlur,
      focus: e.onFocus,
      drop: e.onDrop,
      input: ($) => {
        e.onInput && e.onInput($);
        const { data: C } = $;
        e.maxLength && e.modelValue.length + C.length > e.maxLength && y.emit(t, he, {
          name: "overlength",
          message: "The input text is too long",
          data: C
        });
      }
    }, x = {
      ...g
    }, k = Object.keys(g);
    for (const $ in u) {
      const C = $;
      k.includes(C) ? x[C] = (T, N) => {
        u[C](T, N), T.defaultPrevented || g[C](T, N);
      } : x[C] = u[C];
    }
    return x;
  }, [u, t, a, e]), [h] = _(() => [
    sn.of([...fn, ...gn, ...m, hn]),
    l.history.of(rr()),
    l.language.of(dn({ codeLanguages: cn })),
    // 横向换行
    be.lineWrapping,
    l.update.of(
      be.updateListener.of((g) => {
        g.docChanged && e.onChange(g.state.doc.toString());
      })
    ),
    l.domEvent.of(be.domEventHandlers(b))
  ]), [p] = _(() => U.codeMirrorExtensions(
    n,
    [
      ...h,
      l.theme.of(n === "light" ? br : dr),
      l.autocompletion.of(vr(e.completions))
    ],
    [...m]
  )), v = O(() => {
    var g, x;
    (g = i.current) == null || g.view.dispatch({
      effects: l.history.reconfigure([])
    }), (x = i.current) == null || x.view.dispatch({
      effects: l.history.reconfigure(rr())
    });
  }, [l.history]);
  return S(() => {
    const g = new be({
      doc: e.modelValue,
      parent: o.current,
      extensions: p
    }), x = new co(g);
    i.current = x, setTimeout(() => {
      x.setTabSize(r), x.setDisabled(e.disabled), x.setReadOnly(e.readOnly), e.placeholder && x.setPlaceholder(e.placeholder), typeof e.maxLength == "number" && x.setMaxLength(e.maxLength), e.autoFocus && g.focus(), s.current = !1;
    }, 0);
    const k = () => bn(g), $ = () => pn(g), C = (T) => {
      f(T);
    };
    return y.on(t, {
      name: Ye,
      callback: k
    }), y.on(t, {
      name: Je,
      callback: $
    }), y.on(t, {
      name: Ze,
      callback: C
    }), () => {
      g.destroy(), y.remove(t, Ye, k), y.remove(t, Je, $), y.remove(t, Ze, C), s.current = !0;
    };
  }, []), S(() => {
    const g = (x, k = {}) => {
      var $, C;
      if (x === "image" && k.transform) {
        const T = e.transformImgUrl(k.url);
        if (T instanceof Promise)
          T.then((N) => {
            var D;
            const { text: P, options: L } = Ge(x, i.current, {
              ...k,
              url: N
            });
            (D = i.current) == null || D.replaceSelectedText(P, L, t);
          }).catch((N) => {
            console.error(N);
          });
        else {
          const { text: N, options: P } = Ge(x, i.current, {
            ...k,
            url: T
          });
          ($ = i.current) == null || $.replaceSelectedText(N, P, t);
        }
      } else {
        const { text: T, options: N } = Ge(x, i.current, k);
        (C = i.current) == null || C.replaceSelectedText(T, N, t);
      }
    };
    return y.on(t, {
      name: W,
      callback: g
    }), () => {
      y.remove(t, W, g);
    };
  }, [t, e]), S(() => {
    setTimeout(() => {
      var g;
      (g = i.current) == null || g.view.dispatch({
        effects: l.theme.reconfigure(n === "light" ? br : dr)
      });
    }, 0);
  }, [l.theme, n]), S(() => {
    setTimeout(() => {
      var g;
      (g = i.current) == null || g.view.dispatch({
        effects: [
          l.update.reconfigure(
            be.updateListener.of((x) => {
              x.docChanged && e.onChange(x.state.doc.toString());
            })
          ),
          l.domEvent.reconfigure(be.domEventHandlers(b)),
          l.autocompletion.reconfigure(vr(e.completions))
        ]
      });
    }, 0);
  }, [l.autocompletion, l.domEvent, l.update, b, e]), S(() => {
    var g, x;
    ((g = i.current) == null ? void 0 : g.getValue()) !== e.modelValue && ((x = i.current) == null || x.setValue(e.modelValue));
  }, [e.modelValue]), S(() => {
    var g;
    s.current || (g = i.current) == null || g.setTabSize(r);
  }, [r]), S(() => {
    var g;
    s.current || (g = i.current) == null || g.setPlaceholder(e.placeholder);
  }, [e.placeholder]), S(() => {
    var g;
    s.current || (g = i.current) == null || g.setDisabled(e.disabled);
  }, [e.disabled]), S(() => {
    var g;
    s.current || (g = i.current) == null || g.setDisabled(e.readOnly);
  }, [e.readOnly]), S(() => {
    var g;
    s.current || typeof e.maxLength == "number" && ((g = i.current) == null || g.setMaxLength(e.maxLength));
  }, [e.maxLength]), {
    inputWrapperRef: o,
    codeMirrorUt: i,
    resetHistory: v
  };
}, Do = (e, r) => {
  const { editorId: t } = ne(te);
  S(() => e.noImgZoomIn ? void 0 : (() => {
    const o = document.querySelectorAll(
      `#${t}-preview img:not(.not-zoom):not(.medium-zoom-image)`
    ), i = wn(o, {
      background: "#00000073"
    });
    return () => {
      i.detach();
    };
  })(), [t, r, e.noImgZoomIn, e.setting]);
}, Ro = (e, r, t) => {
  const { editorId: n, usedLanguageText: o, customIcon: i } = ne(te), { formatCopiedText: l = (m) => m } = e;
  S(() => {
    e.setting.preview && document.querySelectorAll(`#${n} .${c}-preview .${c}-code`).forEach((m) => {
      let s = -1;
      const a = m.querySelector(
        `.${c}-copy-button`
      );
      a && (a.onclick = (u) => {
        u.preventDefault(), clearTimeout(s);
        const b = (m.querySelector("input:checked + pre code") || m.querySelector("pre code")).textContent, h = yn(l(b)), { text: p, successTips: v, failTips: g } = o.copyCode, x = h ? v : g;
        a.dataset.isIcon ? a.dataset.tips = x : a.innerHTML = x, s = window.setTimeout(() => {
          a.dataset.isIcon ? a.dataset.tips = p : a.innerHTML = p;
        }, 1500);
      });
    });
  }, [
    i,
    n,
    l,
    r,
    t,
    e.setting.preview,
    o.copyCode
  ]);
}, _o = (e) => {
  const { highlight: r } = ne(te), t = F(U.editorExtensions.highlight.instance), [n, o] = _(!!t.current);
  return S(() => {
    e.noHighlight || Ln("link", {
      ...r.css,
      rel: "stylesheet",
      id: `${c}-hlCss`
    });
  }, [r.css, e.noHighlight]), S(() => {
    e.noHighlight || t.current || (le("link", {
      ...r.css,
      rel: "stylesheet",
      id: `${c}-hlCss`
    }), le(
      "script",
      {
        ...r.js,
        id: `${c}-hljs`,
        onload() {
          t.current = window.hljs, o(!0);
        }
      },
      "hljs"
    ));
  }, [r.css, r.js, e.noHighlight]), { hljsRef: t, hljsInited: n };
}, Fo = (e) => {
  const { theme: r } = ne(te), { noMermaid: t, sanitizeMermaid: n } = e, o = F(U.editorExtensions.mermaid.instance), [i, l] = _(-1), [m] = _(
    () => new Sn({
      max: 1e3,
      // 缓存10分钟
      ttl: 6e5
    })
  ), s = O(() => {
    m.clear();
    const u = o.current;
    !t && u && (u.initialize(
      U.mermaidConfig({
        startOnLoad: !1,
        theme: r === "dark" ? "dark" : "default"
      })
    ), l((f) => f + 1));
  }, [m, t, r]);
  S(s, [s]), S(() => {
    var h, p;
    const { editorExtensions: u, editorExtensionsAttrs: f } = U;
    if (t || o.current)
      return;
    const b = u.mermaid.js;
    /\.mjs/.test(b) ? (le("link", {
      ...(h = f.mermaid) == null ? void 0 : h.js,
      rel: "modulepreload",
      href: b,
      id: `${c}-mermaid-m`
    }), import(
      /* @vite-ignore */
      /* webpackIgnore: true */
      b
    ).then((v) => {
      o.current = v.default, s();
    })) : le(
      "script",
      {
        ...(p = f.mermaid) == null ? void 0 : p.js,
        src: b,
        id: `${c}-mermaid`,
        onload() {
          o.current = window.mermaid, s();
        }
      },
      "mermaid"
    );
  }, [s, t]);
  const a = O(() => {
    if (!t && o.current) {
      const u = document.querySelectorAll(
        `div.${c}-mermaid`
      ), f = document.createElement("div");
      f.style.width = document.body.offsetWidth + "px", f.style.height = document.body.offsetHeight + "px", f.style.position = "fixed", f.style.zIndex = "-10000", f.style.top = "-10000";
      let b = u.length;
      b > 0 && document.body.appendChild(f), u.forEach(async (h) => {
        let p = m.get(h.innerText);
        if (!p) {
          const g = tt(), x = o.current.renderAsync || o.current.render;
          let k = "";
          try {
            k = await x(g, h.innerText, f);
          } catch {
          }
          p = await n(typeof k == "string" ? k : k.svg), m.set(h.innerText, p);
        }
        const v = document.createElement("p");
        v.className = `${c}-mermaid`, v.setAttribute("data-processed", ""), v.innerHTML = p, h.dataset.line !== void 0 && (v.dataset.line = h.dataset.line), h.replaceWith(v), --b === 0 && f.remove();
      });
    }
  }, [m, t, n]);
  return { mermaidRef: o, reRender: i, replaceMermaid: a };
}, Oo = (e) => {
  const r = F(U.editorExtensions.katex.instance), [t, n] = _(!!r.current);
  return S(() => {
    if (e.noKatex || r.current)
      return;
    const { editorExtensions: o } = U;
    le(
      "script",
      {
        src: o.katex.js,
        id: `${c}-katex`,
        onload() {
          r.current = window.katex, n(!0);
        }
      },
      "katex"
    ), le("link", {
      rel: "stylesheet",
      href: o.katex.css,
      id: `${c}-katexCss`
    });
  }, [e.noKatex]), { katexRef: r, katexInited: t };
}, Vo = (e, r) => {
  const t = e.renderer.rules.fence.bind(e.renderer.rules);
  e.renderer.rules.fence = (n, o, i, l, m) => {
    const s = n[o], a = s.content.trim();
    if (s.info === "mermaid") {
      let u;
      return n[o].map && n[o].level === 0 && (u = n[o].map[0], n[o].attrSet("data-line", String(u))), `<div class="${c}-mermaid" ${u !== void 0 ? "data-line=" + u : ""} data-mermaid-theme=${r.themeRef.current}>${a}</div>`;
    }
    return t(n, o, i, l, m);
  };
}, Wo = Vo, Fe = (e, r) => {
  const t = e.attrs ? e.attrs.slice() : [];
  return r.forEach((n) => {
    const o = e.attrIndex(n[0]);
    o < 0 ? t.push(n) : (t[o] = t[o].slice(), t[o][1] += ` ${n[1]}`);
  }), t;
}, xr = (e, r) => {
  let t = !0, n = !0;
  const o = e.posMax, i = r > 0 ? e.src.charCodeAt(r - 1) : -1, l = r + 1 <= o ? e.src.charCodeAt(r + 1) : -1;
  return (i === 32 || i === 9 || l >= 48 && l <= 57) && (n = !1), (l === 32 || l === 9) && (t = !1), {
    can_open: t,
    can_close: n
  };
}, Bo = (e, r) => {
  let t, n, o, i;
  if (e.src[e.pos] !== "$")
    return !1;
  if (o = xr(e, e.pos), !o.can_open)
    return r || (e.pending += "$"), e.pos += 1, !0;
  const l = e.pos + 1;
  for (t = l; (t = e.src.indexOf("$", t)) !== -1; ) {
    for (i = t - 1; e.src[i] === "\\"; )
      i -= 1;
    if ((t - i) % 2 == 1)
      break;
    t += 1;
  }
  return t === -1 ? (r || (e.pending += "$"), e.pos = l, !0) : t - l === 0 ? (r || (e.pending += "$$"), e.pos = l + 1, !0) : (o = xr(e, t), o.can_close ? (r || (n = e.push("math_inline", "math", 0), n.markup = "$", n.content = e.src.slice(l, t)), e.pos = t + 1, !0) : (r || (e.pending += "$"), e.pos = l, !0));
}, zo = (e, r, t, n) => {
  let o, i, l, m, s = !1, a = e.bMarks[r] + e.tShift[r], u = e.eMarks[r];
  if (a + 2 > u || e.src.slice(a, a + 2) !== "$$")
    return !1;
  if (a += 2, o = e.src.slice(a, u), n)
    return !0;
  for (o.trim().slice(-2) === "$$" && (o = o.trim().slice(0, -2), s = !0), l = r; !s && (l++, !(l >= t || (a = e.bMarks[l] + e.tShift[l], u = e.eMarks[l], a < u && e.tShift[l] < e.blkIndent))); )
    e.src.slice(a, u).trim().slice(-2) === "$$" && (m = e.src.slice(0, u).lastIndexOf("$$"), i = e.src.slice(a, m), s = !0);
  e.line = l + 1;
  const f = e.push("math_block", "math", 0);
  return f.block = !0, f.content = (o && o.trim() ? o + `
` : "") + e.getLines(r + 1, l, e.tShift[r], !0) + (i && i.trim() ? i : ""), f.map = [r, e.line], f.markup = "$$", !0;
}, Go = (e, { katexRef: r }) => {
  const t = (o, i, l, m, s) => {
    const a = o[i], u = {
      attrs: Fe(a, [["class", `${c}-katex-inline`]])
    };
    if (r.current) {
      const f = r.current.renderToString(a.content, {
        throwOnError: !1
      });
      return `<span ${s.renderAttrs(u)} data-processed>${f}</span>`;
    } else
      return `<span ${s.renderAttrs(u)}>${a.content}</span>`;
  }, n = (o, i, l, m, s) => {
    const a = o[i], u = {
      attrs: Fe(a, [["class", `${c}-katex-block`]])
    };
    if (r.current) {
      const f = r.current.renderToString(a.content, {
        throwOnError: !1,
        displayMode: !0
      });
      return `<p ${s.renderAttrs(u)} data-processed>${f}</p>`;
    } else
      return `<p ${s.renderAttrs(u)}>${a.content}</p>`;
  };
  e.inline.ruler.after("escape", "math_inline", Bo), e.block.ruler.after("blockquote", "math_block", zo, {
    alt: ["paragraph", "reference", "blockquote", "list"]
  }), e.renderer.rules.math_inline = t, e.renderer.rules.math_block = n;
}, Uo = Go, qo = (e, r) => {
  r = r || {};
  const t = 3, n = r.marker || "!", o = n.charCodeAt(0), i = n.length;
  let l = "", m = "";
  const s = (u, f, b, h, p) => {
    const v = u[f];
    return v.type === "admonition_open" ? u[f].attrPush([
      "class",
      `${c}-admonition ${c}-admonition-${v.info}`
    ]) : v.type === "admonition_title_open" && u[f].attrPush(["class", `${c}-admonition-title`]), p.renderToken(u, f, b);
  }, a = (u) => {
    const f = u.trim().split(" ", 2);
    m = "", l = f[0], f.length > 1 && (m = u.substring(l.length + 2));
  };
  e.block.ruler.before(
    "code",
    "admonition",
    (u, f, b, h) => {
      let p, v, g, x = !1, k = u.bMarks[f] + u.tShift[f], $ = u.eMarks[f];
      if (o !== u.src.charCodeAt(k))
        return !1;
      for (p = k + 1; p <= $ && n[(p - k) % i] === u.src[p]; p++)
        ;
      const C = Math.floor((p - k) / i);
      if (C !== t)
        return !1;
      p -= (p - k) % i;
      const T = u.src.slice(k, p), N = u.src.slice(p, $);
      if (a(N), h)
        return !0;
      for (v = f; v++, !(v >= b || (k = u.bMarks[v] + u.tShift[v], $ = u.eMarks[v], k < $ && u.sCount[v] < u.blkIndent)); )
        if (o === u.src.charCodeAt(k) && !(u.sCount[v] - u.blkIndent >= 4)) {
          for (p = k + 1; p <= $ && n[(p - k) % i] === u.src[p]; p++)
            ;
          if (!(Math.floor((p - k) / i) < C) && (p -= (p - k) % i, p = u.skipSpaces(p), !(p < $))) {
            x = !0;
            break;
          }
        }
      const P = u.parentType, L = u.lineMax;
      return u.parentType = "root", u.lineMax = v, g = u.push("admonition_open", "div", 1), g.markup = T, g.block = !0, g.info = l, g.map = [f, v], m && (g = u.push("admonition_title_open", "p", 1), g.markup = T + " " + l, g.map = [f, v], g = u.push("inline", "", 0), g.content = m, g.map = [f, u.line - 1], g.children = [], g = u.push("admonition_title_close", "p", -1), g.markup = T + " " + l), u.md.block.tokenize(u, f + 1, v), g = u.push("admonition_close", "div", -1), g.markup = u.src.slice(k, p), g.block = !0, u.parentType = P, u.lineMax = L, u.line = v + (x ? 1 : 0), !0;
    },
    {
      alt: ["paragraph", "reference", "blockquote", "list"]
    }
  ), e.renderer.rules.admonition_open = s, e.renderer.rules.admonition_title_open = s, e.renderer.rules.admonition_title_close = s, e.renderer.rules.admonition_close = s;
}, Ko = qo, Xo = (e, r) => {
  e.renderer.rules.heading_open = (t, n) => {
    var m;
    const o = t[n], i = ((m = t[n + 1].children) == null ? void 0 : m.reduce((s, a) => s + (["text", "code_inline"].includes(a.type) && a.content || ""), "")) || "", l = o.markup.length;
    return r.headsRef.current.push({
      text: i,
      level: l
    }), o.map && o.level === 0 && o.attrSet(
      "id",
      r.mdHeadingId(i, l, r.headsRef.current.length)
    ), e.renderer.renderToken(t, n, r);
  }, e.renderer.rules.heading_close = (t, n, o, i, l) => l.renderToken(t, n, o);
}, Zo = Xo, Qo = (e, r) => {
  if (typeof r[e] == "string")
    return r[e];
  const t = `<i class="${c}-iconfont ${c}-icon-${e}"></i>`;
  switch (U.iconfontType) {
    case "svg":
      return `<svg class="${c}-icon" aria-hidden="true"><use xlink:href="#${c}-icon-${e}"></use></svg>`;
    default:
      return t;
  }
}, Jo = Qo, Yo = (e, r) => {
  const t = e.renderer.rules.fence, n = e.utils.unescapeAll, o = /\[(\w*)(?::([\w ]*))?\]/, i = /::(open|close)/, l = (f) => f.info ? n(f.info).trim() : "", m = (f) => {
    const b = l(f), [h = null, p = ""] = (o.exec(b) || []).slice(1);
    return [h, p];
  }, s = (f) => {
    const b = l(f);
    return b ? b.split(/(\s+)/g)[0] : "";
  }, a = (f) => {
    const b = f.info.match(i) || [], h = b[1] === "open" || b[1] !== "close" && r.codeFoldable && f.content.trim().split(`
`).length < r.autoFoldThreshold, p = b[1] || r.codeFoldable ? "details" : "div", v = b[1] || r.codeFoldable ? "summary" : "div";
    return { open: h, tagContainer: p, tagHeader: v };
  }, u = (f, b, h, p, v) => {
    if (f[b].hidden)
      return "";
    const g = r.usedLanguageTextRef.current.copyCode.text, x = r.customIconRef.current.copy || g, k = !!r.customIconRef.current.copy, $ = `<span class="${c}-collapse-tips">${Jo("collapse-tips", r.customIconRef.current)}</span>`, [C] = m(f[b]);
    if (C === null) {
      const { open: q, tagContainer: M, tagHeader: X } = a(f[b]), ae = [["class", `${c}-code`]];
      q && ae.push(["open", ""]);
      const I = {
        attrs: Fe(f[b], ae)
      };
      f[b].info = f[b].info.replace(i, "");
      const E = t(f, b, h, p, v);
      return `<${M} ${v.renderAttrs(I)}>
        <${X} class="${c}-code-head">
          <div class="${c}-code-flag">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="${c}-code-action">
          <span class="${c}-code-lang">${f[b].info.trim()}</span>
          <span class="${c}-copy-button" data-tips="${g}"${k ? " data-is-icon=true" : ""}">${x}</span>
          ${M === "details" ? $ : ""}
        </div>
        </${X}>${E}</${M}>`;
    }
    let T, N, P, L, D = "", V = "", B = "";
    const { open: Q, tagContainer: J, tagHeader: Y } = a(f[b]), K = [["class", `${c}-code`]];
    Q && K.push(["open", ""]);
    const oe = {
      attrs: Fe(f[b], K)
    };
    for (let q = b; q < f.length && (T = f[q], [N, P] = m(T), N === C); q++) {
      T.info = T.info.replace(o, "").replace(i, ""), T.hidden = !0;
      const M = `${c}-codetab-${r.editorId}-${b}-${q - b}`;
      L = q - b > 0 ? "" : "checked", D += `<li>
          <input type="radio" name="${c}-codetab-label-${r.editorId}-${b}" class="${M}" ${L}>
          <label onclick="document.querySelectorAll('.${M}').forEach(e => e.click())">${P || s(T)}</label>
        </li>`, V += `<input type="radio" name="${c}-codetab-pre-${r.editorId}-${b}" class="${M}" ${L}>
      ${t(f, q, h, p, v)}`, B += `<input type="radio" name="${c}-codetab-lang-${r.editorId}-${b}" class="${M}" ${L}>
      <span class=${c}-code-lang>${s(T)}</span>`;
    }
    return `<${J} ${v.renderAttrs(oe)}>
      <${Y} class="${c}-code-head">
        <div class="${c}-code-flag">
          <ul class="${c}-codetab-label">${D}</ul>
        </div>
        <div class="${c}-code-action">
          <span class="${c}-codetab-lang">${B}</span>
          <span class="${c}-copy-button" data-tips="${g}"${k ? " data-is-icon=true" : ""}">${x}</span>
          ${J === "details" ? $ : ""}
        </div>
      </${Y}>${V}</${J}>`;
  };
  e.renderer.rules.fence = u, e.renderer.rules.code_block = u;
}, ea = Yo;
var rt = { exports: {} }, G = {}, nt = { exports: {} }, ve = {};
function Ir() {
  var e = {};
  return e["align-content"] = !1, e["align-items"] = !1, e["align-self"] = !1, e["alignment-adjust"] = !1, e["alignment-baseline"] = !1, e.all = !1, e["anchor-point"] = !1, e.animation = !1, e["animation-delay"] = !1, e["animation-direction"] = !1, e["animation-duration"] = !1, e["animation-fill-mode"] = !1, e["animation-iteration-count"] = !1, e["animation-name"] = !1, e["animation-play-state"] = !1, e["animation-timing-function"] = !1, e.azimuth = !1, e["backface-visibility"] = !1, e.background = !0, e["background-attachment"] = !0, e["background-clip"] = !0, e["background-color"] = !0, e["background-image"] = !0, e["background-origin"] = !0, e["background-position"] = !0, e["background-repeat"] = !0, e["background-size"] = !0, e["baseline-shift"] = !1, e.binding = !1, e.bleed = !1, e["bookmark-label"] = !1, e["bookmark-level"] = !1, e["bookmark-state"] = !1, e.border = !0, e["border-bottom"] = !0, e["border-bottom-color"] = !0, e["border-bottom-left-radius"] = !0, e["border-bottom-right-radius"] = !0, e["border-bottom-style"] = !0, e["border-bottom-width"] = !0, e["border-collapse"] = !0, e["border-color"] = !0, e["border-image"] = !0, e["border-image-outset"] = !0, e["border-image-repeat"] = !0, e["border-image-slice"] = !0, e["border-image-source"] = !0, e["border-image-width"] = !0, e["border-left"] = !0, e["border-left-color"] = !0, e["border-left-style"] = !0, e["border-left-width"] = !0, e["border-radius"] = !0, e["border-right"] = !0, e["border-right-color"] = !0, e["border-right-style"] = !0, e["border-right-width"] = !0, e["border-spacing"] = !0, e["border-style"] = !0, e["border-top"] = !0, e["border-top-color"] = !0, e["border-top-left-radius"] = !0, e["border-top-right-radius"] = !0, e["border-top-style"] = !0, e["border-top-width"] = !0, e["border-width"] = !0, e.bottom = !1, e["box-decoration-break"] = !0, e["box-shadow"] = !0, e["box-sizing"] = !0, e["box-snap"] = !0, e["box-suppress"] = !0, e["break-after"] = !0, e["break-before"] = !0, e["break-inside"] = !0, e["caption-side"] = !1, e.chains = !1, e.clear = !0, e.clip = !1, e["clip-path"] = !1, e["clip-rule"] = !1, e.color = !0, e["color-interpolation-filters"] = !0, e["column-count"] = !1, e["column-fill"] = !1, e["column-gap"] = !1, e["column-rule"] = !1, e["column-rule-color"] = !1, e["column-rule-style"] = !1, e["column-rule-width"] = !1, e["column-span"] = !1, e["column-width"] = !1, e.columns = !1, e.contain = !1, e.content = !1, e["counter-increment"] = !1, e["counter-reset"] = !1, e["counter-set"] = !1, e.crop = !1, e.cue = !1, e["cue-after"] = !1, e["cue-before"] = !1, e.cursor = !1, e.direction = !1, e.display = !0, e["display-inside"] = !0, e["display-list"] = !0, e["display-outside"] = !0, e["dominant-baseline"] = !1, e.elevation = !1, e["empty-cells"] = !1, e.filter = !1, e.flex = !1, e["flex-basis"] = !1, e["flex-direction"] = !1, e["flex-flow"] = !1, e["flex-grow"] = !1, e["flex-shrink"] = !1, e["flex-wrap"] = !1, e.float = !1, e["float-offset"] = !1, e["flood-color"] = !1, e["flood-opacity"] = !1, e["flow-from"] = !1, e["flow-into"] = !1, e.font = !0, e["font-family"] = !0, e["font-feature-settings"] = !0, e["font-kerning"] = !0, e["font-language-override"] = !0, e["font-size"] = !0, e["font-size-adjust"] = !0, e["font-stretch"] = !0, e["font-style"] = !0, e["font-synthesis"] = !0, e["font-variant"] = !0, e["font-variant-alternates"] = !0, e["font-variant-caps"] = !0, e["font-variant-east-asian"] = !0, e["font-variant-ligatures"] = !0, e["font-variant-numeric"] = !0, e["font-variant-position"] = !0, e["font-weight"] = !0, e.grid = !1, e["grid-area"] = !1, e["grid-auto-columns"] = !1, e["grid-auto-flow"] = !1, e["grid-auto-rows"] = !1, e["grid-column"] = !1, e["grid-column-end"] = !1, e["grid-column-start"] = !1, e["grid-row"] = !1, e["grid-row-end"] = !1, e["grid-row-start"] = !1, e["grid-template"] = !1, e["grid-template-areas"] = !1, e["grid-template-columns"] = !1, e["grid-template-rows"] = !1, e["hanging-punctuation"] = !1, e.height = !0, e.hyphens = !1, e.icon = !1, e["image-orientation"] = !1, e["image-resolution"] = !1, e["ime-mode"] = !1, e["initial-letters"] = !1, e["inline-box-align"] = !1, e["justify-content"] = !1, e["justify-items"] = !1, e["justify-self"] = !1, e.left = !1, e["letter-spacing"] = !0, e["lighting-color"] = !0, e["line-box-contain"] = !1, e["line-break"] = !1, e["line-grid"] = !1, e["line-height"] = !1, e["line-snap"] = !1, e["line-stacking"] = !1, e["line-stacking-ruby"] = !1, e["line-stacking-shift"] = !1, e["line-stacking-strategy"] = !1, e["list-style"] = !0, e["list-style-image"] = !0, e["list-style-position"] = !0, e["list-style-type"] = !0, e.margin = !0, e["margin-bottom"] = !0, e["margin-left"] = !0, e["margin-right"] = !0, e["margin-top"] = !0, e["marker-offset"] = !1, e["marker-side"] = !1, e.marks = !1, e.mask = !1, e["mask-box"] = !1, e["mask-box-outset"] = !1, e["mask-box-repeat"] = !1, e["mask-box-slice"] = !1, e["mask-box-source"] = !1, e["mask-box-width"] = !1, e["mask-clip"] = !1, e["mask-image"] = !1, e["mask-origin"] = !1, e["mask-position"] = !1, e["mask-repeat"] = !1, e["mask-size"] = !1, e["mask-source-type"] = !1, e["mask-type"] = !1, e["max-height"] = !0, e["max-lines"] = !1, e["max-width"] = !0, e["min-height"] = !0, e["min-width"] = !0, e["move-to"] = !1, e["nav-down"] = !1, e["nav-index"] = !1, e["nav-left"] = !1, e["nav-right"] = !1, e["nav-up"] = !1, e["object-fit"] = !1, e["object-position"] = !1, e.opacity = !1, e.order = !1, e.orphans = !1, e.outline = !1, e["outline-color"] = !1, e["outline-offset"] = !1, e["outline-style"] = !1, e["outline-width"] = !1, e.overflow = !1, e["overflow-wrap"] = !1, e["overflow-x"] = !1, e["overflow-y"] = !1, e.padding = !0, e["padding-bottom"] = !0, e["padding-left"] = !0, e["padding-right"] = !0, e["padding-top"] = !0, e.page = !1, e["page-break-after"] = !1, e["page-break-before"] = !1, e["page-break-inside"] = !1, e["page-policy"] = !1, e.pause = !1, e["pause-after"] = !1, e["pause-before"] = !1, e.perspective = !1, e["perspective-origin"] = !1, e.pitch = !1, e["pitch-range"] = !1, e["play-during"] = !1, e.position = !1, e["presentation-level"] = !1, e.quotes = !1, e["region-fragment"] = !1, e.resize = !1, e.rest = !1, e["rest-after"] = !1, e["rest-before"] = !1, e.richness = !1, e.right = !1, e.rotation = !1, e["rotation-point"] = !1, e["ruby-align"] = !1, e["ruby-merge"] = !1, e["ruby-position"] = !1, e["shape-image-threshold"] = !1, e["shape-outside"] = !1, e["shape-margin"] = !1, e.size = !1, e.speak = !1, e["speak-as"] = !1, e["speak-header"] = !1, e["speak-numeral"] = !1, e["speak-punctuation"] = !1, e["speech-rate"] = !1, e.stress = !1, e["string-set"] = !1, e["tab-size"] = !1, e["table-layout"] = !1, e["text-align"] = !0, e["text-align-last"] = !0, e["text-combine-upright"] = !0, e["text-decoration"] = !0, e["text-decoration-color"] = !0, e["text-decoration-line"] = !0, e["text-decoration-skip"] = !0, e["text-decoration-style"] = !0, e["text-emphasis"] = !0, e["text-emphasis-color"] = !0, e["text-emphasis-position"] = !0, e["text-emphasis-style"] = !0, e["text-height"] = !0, e["text-indent"] = !0, e["text-justify"] = !0, e["text-orientation"] = !0, e["text-overflow"] = !0, e["text-shadow"] = !0, e["text-space-collapse"] = !0, e["text-transform"] = !0, e["text-underline-position"] = !0, e["text-wrap"] = !0, e.top = !1, e.transform = !1, e["transform-origin"] = !1, e["transform-style"] = !1, e.transition = !1, e["transition-delay"] = !1, e["transition-duration"] = !1, e["transition-property"] = !1, e["transition-timing-function"] = !1, e["unicode-bidi"] = !1, e["vertical-align"] = !1, e.visibility = !1, e["voice-balance"] = !1, e["voice-duration"] = !1, e["voice-family"] = !1, e["voice-pitch"] = !1, e["voice-range"] = !1, e["voice-rate"] = !1, e["voice-stress"] = !1, e["voice-volume"] = !1, e.volume = !1, e["white-space"] = !1, e.widows = !1, e.width = !0, e["will-change"] = !1, e["word-break"] = !0, e["word-spacing"] = !0, e["word-wrap"] = !0, e["wrap-flow"] = !1, e["wrap-through"] = !1, e["writing-mode"] = !1, e["z-index"] = !1, e;
}
function ta(e, r, t) {
}
function ra(e, r, t) {
}
var na = /javascript\s*\:/img;
function oa(e, r) {
  return na.test(r) ? "" : r;
}
ve.whiteList = Ir();
ve.getDefaultWhiteList = Ir;
ve.onAttr = ta;
ve.onIgnoreAttr = ra;
ve.safeAttrValue = oa;
var aa = {
  indexOf: function(e, r) {
    var t, n;
    if (Array.prototype.indexOf)
      return e.indexOf(r);
    for (t = 0, n = e.length; t < n; t++)
      if (e[t] === r)
        return t;
    return -1;
  },
  forEach: function(e, r, t) {
    var n, o;
    if (Array.prototype.forEach)
      return e.forEach(r, t);
    for (n = 0, o = e.length; n < o; n++)
      r.call(t, e[n], n, e);
  },
  trim: function(e) {
    return String.prototype.trim ? e.trim() : e.replace(/(^\s*)|(\s*$)/g, "");
  },
  trimRight: function(e) {
    return String.prototype.trimRight ? e.trimRight() : e.replace(/(\s*$)/g, "");
  }
}, ye = aa;
function ia(e, r) {
  e = ye.trimRight(e), e[e.length - 1] !== ";" && (e += ";");
  var t = e.length, n = !1, o = 0, i = 0, l = "";
  function m() {
    if (!n) {
      var u = ye.trim(e.slice(o, i)), f = u.indexOf(":");
      if (f !== -1) {
        var b = ye.trim(u.slice(0, f)), h = ye.trim(u.slice(f + 1));
        if (b) {
          var p = r(o, l.length, b, h, u);
          p && (l += p + "; ");
        }
      }
    }
    o = i + 1;
  }
  for (; i < t; i++) {
    var s = e[i];
    if (s === "/" && e[i + 1] === "*") {
      var a = e.indexOf("*/", i + 2);
      if (a === -1)
        break;
      i = a + 1, o = i + 1, n = !1;
    } else
      s === "(" ? n = !0 : s === ")" ? n = !1 : s === ";" ? n || m() : s === `
` && m();
  }
  return ye.trim(l);
}
var la = ia, Pe = ve, sa = la;
function kr(e) {
  return e == null;
}
function ca(e) {
  var r = {};
  for (var t in e)
    r[t] = e[t];
  return r;
}
function Hr(e) {
  e = ca(e || {}), e.whiteList = e.whiteList || Pe.whiteList, e.onAttr = e.onAttr || Pe.onAttr, e.onIgnoreAttr = e.onIgnoreAttr || Pe.onIgnoreAttr, e.safeAttrValue = e.safeAttrValue || Pe.safeAttrValue, this.options = e;
}
Hr.prototype.process = function(e) {
  if (e = e || "", e = e.toString(), !e)
    return "";
  var r = this, t = r.options, n = t.whiteList, o = t.onAttr, i = t.onIgnoreAttr, l = t.safeAttrValue, m = sa(e, function(s, a, u, f, b) {
    var h = n[u], p = !1;
    if (h === !0 ? p = h : typeof h == "function" ? p = h(f) : h instanceof RegExp && (p = h.test(f)), p !== !0 && (p = !1), f = l(u, f), !!f) {
      var v = {
        position: a,
        sourcePosition: s,
        source: b,
        isWhite: p
      };
      if (p) {
        var g = o(u, f, v);
        return kr(g) ? u + ":" + f : g;
      } else {
        var g = i(u, f, v);
        if (!kr(g))
          return g;
      }
    }
  });
  return m;
};
var da = Hr;
(function(e, r) {
  var t = ve, n = da;
  function o(l, m) {
    var s = new n(m);
    return s.process(l);
  }
  r = e.exports = o, r.FilterCSS = n;
  for (var i in t)
    r[i] = t[i];
  typeof window < "u" && (window.filterCSS = e.exports);
})(nt, nt.exports);
var it = nt.exports, lt = {
  indexOf: function(e, r) {
    var t, n;
    if (Array.prototype.indexOf)
      return e.indexOf(r);
    for (t = 0, n = e.length; t < n; t++)
      if (e[t] === r)
        return t;
    return -1;
  },
  forEach: function(e, r, t) {
    var n, o;
    if (Array.prototype.forEach)
      return e.forEach(r, t);
    for (n = 0, o = e.length; n < o; n++)
      r.call(t, e[n], n, e);
  },
  trim: function(e) {
    return String.prototype.trim ? e.trim() : e.replace(/(^\s*)|(\s*$)/g, "");
  },
  spaceIndex: function(e) {
    var r = /\s|\n|\t/, t = r.exec(e);
    return t ? t.index : -1;
  }
}, ua = it.FilterCSS, ma = it.getDefaultWhiteList, Oe = lt;
function Pr() {
  return {
    a: ["target", "href", "title"],
    abbr: ["title"],
    address: [],
    area: ["shape", "coords", "href", "alt"],
    article: [],
    aside: [],
    audio: [
      "autoplay",
      "controls",
      "crossorigin",
      "loop",
      "muted",
      "preload",
      "src"
    ],
    b: [],
    bdi: ["dir"],
    bdo: ["dir"],
    big: [],
    blockquote: ["cite"],
    br: [],
    caption: [],
    center: [],
    cite: [],
    code: [],
    col: ["align", "valign", "span", "width"],
    colgroup: ["align", "valign", "span", "width"],
    dd: [],
    del: ["datetime"],
    details: ["open"],
    div: [],
    dl: [],
    dt: [],
    em: [],
    figcaption: [],
    figure: [],
    font: ["color", "size", "face"],
    footer: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    header: [],
    hr: [],
    i: [],
    img: ["src", "alt", "title", "width", "height", "loading"],
    ins: ["datetime"],
    kbd: [],
    li: [],
    mark: [],
    nav: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    section: [],
    small: [],
    span: [],
    sub: [],
    summary: [],
    sup: [],
    strong: [],
    strike: [],
    table: ["width", "border", "align", "valign"],
    tbody: ["align", "valign"],
    td: ["width", "rowspan", "colspan", "align", "valign"],
    tfoot: ["align", "valign"],
    th: ["width", "rowspan", "colspan", "align", "valign"],
    thead: ["align", "valign"],
    tr: ["rowspan", "align", "valign"],
    tt: [],
    u: [],
    ul: [],
    video: [
      "autoplay",
      "controls",
      "crossorigin",
      "loop",
      "muted",
      "playsinline",
      "poster",
      "preload",
      "src",
      "height",
      "width"
    ]
  };
}
var Mr = new ua();
function fa(e, r, t) {
}
function ga(e, r, t) {
}
function ha(e, r, t) {
}
function ba(e, r, t) {
}
function Dr(e) {
  return e.replace(va, "&lt;").replace(xa, "&gt;");
}
function pa(e, r, t, n) {
  if (t = Wr(t), r === "href" || r === "src") {
    if (t = Oe.trim(t), t === "#")
      return "#";
    if (!(t.substr(0, 7) === "http://" || t.substr(0, 8) === "https://" || t.substr(0, 7) === "mailto:" || t.substr(0, 4) === "tel:" || t.substr(0, 11) === "data:image/" || t.substr(0, 6) === "ftp://" || t.substr(0, 2) === "./" || t.substr(0, 3) === "../" || t[0] === "#" || t[0] === "/"))
      return "";
  } else if (r === "background") {
    if (Me.lastIndex = 0, Me.test(t))
      return "";
  } else if (r === "style") {
    if (wr.lastIndex = 0, wr.test(t) || (yr.lastIndex = 0, yr.test(t) && (Me.lastIndex = 0, Me.test(t))))
      return "";
    n !== !1 && (n = n || Mr, t = n.process(t));
  }
  return t = Br(t), t;
}
var va = /</g, xa = />/g, ka = /"/g, wa = /&quot;/g, ya = /&#([a-zA-Z0-9]*);?/gim, Ca = /&colon;?/gim, $a = /&newline;?/gim, Me = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi, wr = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi, yr = /u\s*r\s*l\s*\(.*/gi;
function Rr(e) {
  return e.replace(ka, "&quot;");
}
function _r(e) {
  return e.replace(wa, '"');
}
function Fr(e) {
  return e.replace(ya, function(t, n) {
    return n[0] === "x" || n[0] === "X" ? String.fromCharCode(parseInt(n.substr(1), 16)) : String.fromCharCode(parseInt(n, 10));
  });
}
function Or(e) {
  return e.replace(Ca, ":").replace($a, " ");
}
function Vr(e) {
  for (var r = "", t = 0, n = e.length; t < n; t++)
    r += e.charCodeAt(t) < 32 ? " " : e.charAt(t);
  return Oe.trim(r);
}
function Wr(e) {
  return e = _r(e), e = Fr(e), e = Or(e), e = Vr(e), e;
}
function Br(e) {
  return e = Rr(e), e = Dr(e), e;
}
function Ta() {
  return "";
}
function Sa(e, r) {
  typeof r != "function" && (r = function() {
  });
  var t = !Array.isArray(e);
  function n(l) {
    return t ? !0 : Oe.indexOf(e, l) !== -1;
  }
  var o = [], i = !1;
  return {
    onIgnoreTag: function(l, m, s) {
      if (n(l))
        if (s.isClosing) {
          var a = "[/removed]", u = s.position + a.length;
          return o.push([
            i !== !1 ? i : s.position,
            u
          ]), i = !1, a;
        } else
          return i || (i = s.position), "[removed]";
      else
        return r(l, m, s);
    },
    remove: function(l) {
      var m = "", s = 0;
      return Oe.forEach(o, function(a) {
        m += l.slice(s, a[0]), s = a[1];
      }), m += l.slice(s), m;
    }
  };
}
function Na(e) {
  for (var r = "", t = 0; t < e.length; ) {
    var n = e.indexOf("<!--", t);
    if (n === -1) {
      r += e.slice(t);
      break;
    }
    r += e.slice(t, n);
    var o = e.indexOf("-->", n);
    if (o === -1)
      break;
    t = o + 3;
  }
  return r;
}
function ja(e) {
  var r = e.split("");
  return r = r.filter(function(t) {
    var n = t.charCodeAt(0);
    return n === 127 ? !1 : n <= 31 ? n === 10 || n === 13 : !0;
  }), r.join("");
}
G.whiteList = Pr();
G.getDefaultWhiteList = Pr;
G.onTag = fa;
G.onIgnoreTag = ga;
G.onTagAttr = ha;
G.onIgnoreTagAttr = ba;
G.safeAttrValue = pa;
G.escapeHtml = Dr;
G.escapeQuote = Rr;
G.unescapeQuote = _r;
G.escapeHtmlEntities = Fr;
G.escapeDangerHtml5Entities = Or;
G.clearNonPrintableCharacter = Vr;
G.friendlyAttrValue = Wr;
G.escapeAttrValue = Br;
G.onIgnoreTagStripAll = Ta;
G.StripTagBody = Sa;
G.stripCommentTag = Na;
G.stripBlankChar = ja;
G.attributeWrapSign = '"';
G.cssFilter = Mr;
G.getDefaultCSSWhiteList = ma;
var We = {}, ge = lt;
function Aa(e) {
  var r = ge.spaceIndex(e), t;
  return r === -1 ? t = e.slice(1, -1) : t = e.slice(1, r + 1), t = ge.trim(t).toLowerCase(), t.slice(0, 1) === "/" && (t = t.slice(1)), t.slice(-1) === "/" && (t = t.slice(0, -1)), t;
}
function Ea(e) {
  return e.slice(0, 2) === "</";
}
function La(e, r, t) {
  var n = "", o = 0, i = !1, l = !1, m = 0, s = e.length, a = "", u = "";
  e:
    for (m = 0; m < s; m++) {
      var f = e.charAt(m);
      if (i === !1) {
        if (f === "<") {
          i = m;
          continue;
        }
      } else if (l === !1) {
        if (f === "<") {
          n += t(e.slice(o, m)), i = m, o = m;
          continue;
        }
        if (f === ">" || m === s - 1) {
          n += t(e.slice(o, i)), u = e.slice(i, m + 1), a = Aa(u), n += r(
            i,
            n.length,
            a,
            u,
            Ea(u)
          ), o = m + 1, i = !1;
          continue;
        }
        if (f === '"' || f === "'")
          for (var b = 1, h = e.charAt(m - b); h.trim() === "" || h === "="; ) {
            if (h === "=") {
              l = f;
              continue e;
            }
            h = e.charAt(m - ++b);
          }
      } else if (f === l) {
        l = !1;
        continue;
      }
    }
  return o < s && (n += t(e.substr(o))), n;
}
var Ia = /[^a-zA-Z0-9\\_:.-]/gim;
function Ha(e, r) {
  var t = 0, n = 0, o = [], i = !1, l = e.length;
  function m(b, h) {
    if (b = ge.trim(b), b = b.replace(Ia, "").toLowerCase(), !(b.length < 1)) {
      var p = r(b, h || "");
      p && o.push(p);
    }
  }
  for (var s = 0; s < l; s++) {
    var a = e.charAt(s), u, f;
    if (i === !1 && a === "=") {
      i = e.slice(t, s), t = s + 1, n = e.charAt(t) === '"' || e.charAt(t) === "'" ? t : Ma(e, s + 1);
      continue;
    }
    if (i !== !1 && s === n) {
      if (f = e.indexOf(a, s + 1), f === -1)
        break;
      u = ge.trim(e.slice(n + 1, f)), m(i, u), i = !1, s = f, t = s + 1;
      continue;
    }
    if (/\s|\n|\t/.test(a))
      if (e = e.replace(/\s|\n|\t/g, " "), i === !1)
        if (f = Pa(e, s), f === -1) {
          u = ge.trim(e.slice(t, s)), m(u), i = !1, t = s + 1;
          continue;
        } else {
          s = f - 1;
          continue;
        }
      else if (f = Da(e, s - 1), f === -1) {
        u = ge.trim(e.slice(t, s)), u = Cr(u), m(i, u), i = !1, t = s + 1;
        continue;
      } else
        continue;
  }
  return t < e.length && (i === !1 ? m(e.slice(t)) : m(i, Cr(ge.trim(e.slice(t))))), ge.trim(o.join(" "));
}
function Pa(e, r) {
  for (; r < e.length; r++) {
    var t = e[r];
    if (t !== " ")
      return t === "=" ? r : -1;
  }
}
function Ma(e, r) {
  for (; r < e.length; r++) {
    var t = e[r];
    if (t !== " ")
      return t === "'" || t === '"' ? r : -1;
  }
}
function Da(e, r) {
  for (; r > 0; r--) {
    var t = e[r];
    if (t !== " ")
      return t === "=" ? r : -1;
  }
}
function Ra(e) {
  return e[0] === '"' && e[e.length - 1] === '"' || e[0] === "'" && e[e.length - 1] === "'";
}
function Cr(e) {
  return Ra(e) ? e.substr(1, e.length - 2) : e;
}
We.parseTag = La;
We.parseAttr = Ha;
var _a = it.FilterCSS, se = G, zr = We, Fa = zr.parseTag, Oa = zr.parseAttr, Re = lt;
function De(e) {
  return e == null;
}
function Va(e) {
  var r = Re.spaceIndex(e);
  if (r === -1)
    return {
      html: "",
      closing: e[e.length - 2] === "/"
    };
  e = Re.trim(e.slice(r + 1, -1));
  var t = e[e.length - 1] === "/";
  return t && (e = Re.trim(e.slice(0, -1))), {
    html: e,
    closing: t
  };
}
function Wa(e) {
  var r = {};
  for (var t in e)
    r[t] = e[t];
  return r;
}
function Ba(e) {
  var r = {};
  for (var t in e)
    Array.isArray(e[t]) ? r[t.toLowerCase()] = e[t].map(function(n) {
      return n.toLowerCase();
    }) : r[t.toLowerCase()] = e[t];
  return r;
}
function Gr(e) {
  e = Wa(e || {}), e.stripIgnoreTag && (e.onIgnoreTag && console.error(
    'Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'
  ), e.onIgnoreTag = se.onIgnoreTagStripAll), e.whiteList || e.allowList ? e.whiteList = Ba(e.whiteList || e.allowList) : e.whiteList = se.whiteList, this.attributeWrapSign = e.singleQuotedAttributeValue === !0 ? "'" : se.attributeWrapSign, e.onTag = e.onTag || se.onTag, e.onTagAttr = e.onTagAttr || se.onTagAttr, e.onIgnoreTag = e.onIgnoreTag || se.onIgnoreTag, e.onIgnoreTagAttr = e.onIgnoreTagAttr || se.onIgnoreTagAttr, e.safeAttrValue = e.safeAttrValue || se.safeAttrValue, e.escapeHtml = e.escapeHtml || se.escapeHtml, this.options = e, e.css === !1 ? this.cssFilter = !1 : (e.css = e.css || {}, this.cssFilter = new _a(e.css));
}
Gr.prototype.process = function(e) {
  if (e = e || "", e = e.toString(), !e)
    return "";
  var r = this, t = r.options, n = t.whiteList, o = t.onTag, i = t.onIgnoreTag, l = t.onTagAttr, m = t.onIgnoreTagAttr, s = t.safeAttrValue, a = t.escapeHtml, u = r.attributeWrapSign, f = r.cssFilter;
  t.stripBlankChar && (e = se.stripBlankChar(e)), t.allowCommentTag || (e = se.stripCommentTag(e));
  var b = !1;
  t.stripIgnoreTagBody && (b = se.StripTagBody(
    t.stripIgnoreTagBody,
    i
  ), i = b.onIgnoreTag);
  var h = Fa(
    e,
    function(p, v, g, x, k) {
      var $ = {
        sourcePosition: p,
        position: v,
        isClosing: k,
        isWhite: Object.prototype.hasOwnProperty.call(n, g)
      }, C = o(g, x, $);
      if (!De(C))
        return C;
      if ($.isWhite) {
        if ($.isClosing)
          return "</" + g + ">";
        var T = Va(x), N = n[g], P = Oa(T.html, function(L, D) {
          var V = Re.indexOf(N, L) !== -1, B = l(g, L, D, V);
          return De(B) ? V ? (D = s(g, L, D, f), D ? L + "=" + u + D + u : L) : (B = m(g, L, D, V), De(B) ? void 0 : B) : B;
        });
        return x = "<" + g, P && (x += " " + P), T.closing && (x += " /"), x += ">", x;
      } else
        return C = i(g, x, $), De(C) ? a(x) : C;
    },
    a
  );
  return b && (h = b.remove(h)), h;
};
var za = Gr;
(function(e, r) {
  var t = G, n = We, o = za;
  function i(m, s) {
    var a = new o(s);
    return a.process(m);
  }
  r = e.exports = i, r.filterXSS = i, r.FilterXSS = o, function() {
    for (var m in t)
      r[m] = t[m];
    for (var s in n)
      r[s] = n[s];
  }(), typeof window < "u" && (window.filterXSS = e.exports);
  function l() {
    return typeof self < "u" && typeof DedicatedWorkerGlobalScope < "u" && self instanceof DedicatedWorkerGlobalScope;
  }
  l() && (self.filterXSS = e.exports);
})(rt, rt.exports);
var Se = rt.exports;
const Ga = /* @__PURE__ */ An(Se), Ua = /* @__PURE__ */ jn({
  __proto__: null,
  default: Ga
}, [Se]), $r = {
  img: ["class"],
  // 支持任务列表
  input: ["class", "disabled", "type", "checked"],
  // 主要支持youtobe、腾讯视频、哔哩哔哩等内嵌视频代码
  iframe: [
    "class",
    "width",
    "height",
    "src",
    "title",
    "border",
    "frameborder",
    "framespacing",
    "allow",
    "allowfullscreen"
  ]
}, qa = (e, r) => {
  const { extendedWhiteList: t = {}, xss: n = {} } = r;
  let o;
  if (typeof n == "function")
    o = new Se.FilterXSS(n(Ua));
  else {
    const i = Se.getDefaultWhiteList();
    [...Object.keys(t), ...Object.keys($r)].forEach((m) => {
      const s = i[m] || [], a = $r[m] || [], u = t[m] || [];
      i[m] = [
        .../* @__PURE__ */ new Set([...s, ...a, ...u])
      ];
    }), o = new Se.FilterXSS({
      whiteList: i,
      // 自定义的优先级最高
      ...n
    });
  }
  e.core.ruler.after("linkify", "xss", (i) => {
    for (let l = 0; l < i.tokens.length; l++) {
      const m = i.tokens[l];
      switch (m.type) {
        case "html_block": {
          m.content = o.process(m.content);
          break;
        }
        case "inline": {
          (m.children || []).forEach((a) => {
            a.type === "html_inline" && (a.content = o.process(a.content));
          });
          break;
        }
      }
    }
  });
}, Ka = qa, Xa = (e) => {
  e.core.ruler.push("init-line-number", (r) => (r.tokens.forEach((t) => {
    t.map && (t.attrs || (t.attrs = []), t.attrs.push(["data-line", t.map[0].toString()]));
  }), !0));
}, Za = (e, r) => {
  const {
    modelValue: t,
    sanitize: n,
    mdHeadingId: o,
    codeFoldable: i,
    autoFoldThreshold: l,
    noKatex: m,
    noMermaid: s,
    noHighlight: a,
    setting: u,
    onHtmlChanged: f,
    onGetCatalog: b
  } = e, { editorConfig: h, markdownItConfig: p, markdownItPlugins: v } = U, { editorId: g, language: x, showCodeRowNumber: k, theme: $, usedLanguageText: C, customIcon: T } = ne(te), N = F([]), P = F($);
  S(() => {
    P.current = $;
  }, [$]);
  const L = F(C);
  S(() => {
    L.current = C;
  }, [C]);
  const D = F(T);
  S(() => {
    D.current = T;
  }, [T]);
  const { hljsRef: V, hljsInited: B } = _o(e), { katexRef: Q, katexInited: J } = Oo(e), { reRender: Y, replaceMermaid: K } = Fo(e), [oe] = _(() => {
    const j = Cn({
      html: !0,
      breaks: !0,
      linkify: !0
    });
    p(j, {
      editorId: g
    });
    const z = [
      {
        type: "image",
        plugin: $n,
        options: { figcaption: !0, classes: "md-zoom" }
      },
      {
        type: "admonition",
        plugin: Ko,
        options: {}
      },
      {
        type: "taskList",
        plugin: Tn,
        options: {}
      },
      {
        type: "heading",
        plugin: Zo,
        options: { mdHeadingId: o, headsRef: N }
      },
      {
        type: "code",
        plugin: ea,
        options: {
          editorId: g,
          usedLanguageTextRef: L,
          // showCodeRowNumber,
          codeFoldable: i,
          autoFoldThreshold: l,
          customIconRef: D
        }
      },
      {
        type: "xss",
        plugin: Ka,
        options: {}
      }
    ];
    m || z.push({
      type: "katex",
      plugin: Uo,
      options: { katexRef: Q }
    }), s || z.push({
      type: "mermaid",
      plugin: Wo,
      options: { themeRef: P }
    }), v(z, {
      editorId: g
    }).forEach((re) => {
      j.use(re.plugin, re.options);
    });
    const Z = j.options.highlight;
    return j.set({
      highlight: (re, ie, ue) => {
        if (Z) {
          const xe = Z(re, ie, ue);
          if (xe)
            return xe;
        }
        let ce;
        !a && V.current ? V.current.getLanguage(ie) ? ce = V.current.highlight(re, {
          language: ie,
          ignoreIllegals: !0
        }).value : ce = V.current.highlightAuto(re).value : ce = oe.utils.escapeHtml(re);
        const Ae = k ? Qr(ce.replace(/^\n+|\n+$/g, "")) : `<span class="${c}-code-block">${ce.replace(/^\n+|\n+$/g, "")}</span>`;
        return `<pre><code class="language-${ie}" language=${ie}>${Ae}</code></pre>`;
      }
    }), Xa(j), j;
  }), [q, M] = _(`_article-key_${tt()}`), [X, ae] = _(() => n(oe.render(t))), I = ee(() => (a || B) && (m || J), [B, J, a, m]), E = F(!0), A = O(() => {
    N.current = [];
    const j = n(oe.render(t));
    ae(j);
  }, [oe, t, n]);
  return S(() => {
    y.emit(g, Ce, X), f == null || f(X), b == null || b(N.current), y.emit(g, Be, N.current);
  }, [g, X, q, b, f]), S(() => {
    u.preview && y.emit(g, Be, N.current);
  }, [g, u.preview]), S(() => {
    if (E.current) {
      E.current = !1;
      return;
    }
    const j = setTimeout(
      () => {
        A();
      },
      r ? 0 : h.renderDelay
    );
    return () => {
      clearTimeout(j);
    };
  }, [I, $, A, x, r, h.renderDelay]), S(() => {
    K();
  }, [X, q, Y, K]), S(() => {
    const j = () => {
      y.emit(g, Be, N.current);
    };
    return y.on(g, {
      name: er,
      callback: j
    }), () => {
      y.remove(g, er, j);
    };
  }, [g]), S(() => {
    const j = () => {
      M(`_article-key_${tt()}`), A();
    };
    return y.on(g, {
      name: Xe,
      callback: j
    }), () => {
      y.remove(g, Xe, j);
    };
  }, [g, A]), { html: X, key: q };
}, Qa = (e, r, t) => {
  const [n, o] = _({
    width: e.inputBoxWitdh
  }), [i, l] = _({
    left: e.inputBoxWitdh
  }), m = F(e.inputBoxWitdh);
  return S(() => {
    var h, p, v, g;
    const s = ((h = r.current) == null ? void 0 : h.offsetWidth) || 0, a = ((p = r.current) == null ? void 0 : p.getBoundingClientRect().x) || 0, u = (x) => {
      var C;
      let k = x.x - a;
      k < Le ? k = Le : k > s - Le && (k = s - Le);
      const $ = `${k}px`;
      o((T) => ({
        ...T,
        width: $
      })), l((T) => ({
        ...T,
        left: $
      })), m.current = $, (C = e.onInputBoxWitdhChange) == null || C.call(e, $);
    }, f = () => {
      l((x) => ({
        ...x
      })), document.addEventListener("mousemove", u);
    }, b = () => {
      l((x) => ({
        ...x
      })), document.removeEventListener("mousemove", u);
    };
    return (v = t.current) == null || v.addEventListener("mousedown", f), (g = t.current) == null || g.addEventListener("mouseup", b), () => {
      var x, k;
      (x = t.current) == null || x.removeEventListener("mousedown", f), (k = t.current) == null || k.removeEventListener("mouseup", b);
    };
  }, [r, e, t]), S(() => {
    e.inputBoxWitdh && (m.current = e.inputBoxWitdh, o((s) => ({
      ...s,
      width: e.inputBoxWitdh
    })), l((s) => ({
      ...s,
      left: e.inputBoxWitdh
    })));
  }, [e.inputBoxWitdh]), S(() => {
    const s = e.setting.previewOnly;
    let a = "", u = "";
    s ? (a = "0%", u = "none") : !e.setting.htmlPreview && !e.setting.preview ? (a = "100%", u = "none") : (a = m.current, u = "initial"), o((f) => ({
      ...f,
      width: a
    })), l((f) => ({
      ...f,
      display: u
    }));
  }, [e.setting.htmlPreview, e.setting.preview, e.setting.previewOnly]), { inputWrapperStyle: n, resizeOperateStyle: i };
}, Ja = (e) => {
  const { previewOnly: r = !1 } = e, { editorId: t, previewTheme: n, showCodeRowNumber: o } = ne(te), { html: i, key: l } = Za(e, !!r);
  Ro(e, i, l), Do(e, i);
  const m = ee(() => /* @__PURE__ */ d.jsx(
    "div",
    {
      id: `${t}-preview`,
      className: Ve([
        `${c}-preview`,
        `${n}-theme`,
        o && `${c}-scrn`
      ]),
      dangerouslySetInnerHTML: { __html: i }
    },
    l
  ), [t, i, l, n, o]);
  return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    e.setting.preview && /* @__PURE__ */ d.jsx(
      "div",
      {
        id: `${t}-preview-wrapper`,
        className: `${c}-preview-wrapper`,
        children: m
      },
      "content-preview-wrapper"
    ),
    !r && e.setting.htmlPreview && /* @__PURE__ */ d.jsx(
      "div",
      {
        id: `${t}-html-wrapper`,
        className: `${c}-preview-wrapper`,
        children: /* @__PURE__ */ d.jsx("div", { className: `${c}-html`, children: i })
      },
      "html-preview-wrapper"
    )
  ] });
}, Ya = Nr((e, r) => {
  const { onHtmlChanged: t } = e, { editorId: n } = ne(te), [o, i] = _(""), l = F(null), m = F(null), s = O(
    (p) => {
      i(p), t == null || t(p);
    },
    [t]
  ), { inputWrapperRef: a, codeMirrorUt: u, resetHistory: f } = Mo(e), { inputWrapperStyle: b, resizeOperateStyle: h } = Qa(
    e,
    l,
    m
  );
  return so(e, o, u), Tr(
    r,
    () => ({
      getSelectedText() {
        var p;
        return (p = u.current) == null ? void 0 : p.getSelectedText();
      },
      focus(p) {
        var v;
        (v = u.current) == null || v.focus(p);
      },
      resetHistory: f
    }),
    [u, f]
  ), /* @__PURE__ */ d.jsxs(
    "div",
    {
      className: `${c}-content${e.setting.htmlPreview || e.setting.preview ? " has-preview" : ""}`,
      ref: l,
      children: [
        /* @__PURE__ */ d.jsx(
          "div",
          {
            className: `${c}-input-wrapper`,
            style: b,
            ref: a
          }
        ),
        (e.setting.htmlPreview || e.setting.preview) && /* @__PURE__ */ d.jsx(
          "div",
          {
            className: `${c}-resize-operate`,
            style: h,
            ref: m
          }
        ),
        /* @__PURE__ */ d.jsx(
          Ja,
          {
            modelValue: e.modelValue,
            setting: e.setting,
            onHtmlChanged: s,
            onGetCatalog: e.onGetCatalog,
            mdHeadingId: e.mdHeadingId,
            noMermaid: e.noMermaid,
            sanitize: e.sanitize,
            noKatex: e.noKatex,
            formatCopiedText: e.formatCopiedText,
            noHighlight: e.noHighlight,
            noImgZoomIn: e.noImgZoomIn,
            sanitizeMermaid: e.sanitizeMermaid,
            codeFoldable: e.codeFoldable,
            autoFoldThreshold: e.autoFoldThreshold
          },
          "display-editor"
        ),
        e.catalogVisible && /* @__PURE__ */ d.jsx(
          Jr,
          {
            theme: e.theme,
            className: `${c}-catalog-editor`,
            editorId: n,
            mdHeadingId: e.mdHeadingId
          },
          "internal-catalog"
        )
      ]
    }
  );
}), ei = ot.memo(Ya), ti = ({ modelValue: e }) => {
  const { usedLanguageText: r } = ne(te);
  return ee(() => {
    var t;
    return /* @__PURE__ */ d.jsxs("div", { className: `${c}-footer-item`, children: [
      /* @__PURE__ */ d.jsx("label", { className: `${c}-footer-label`, children: `${(t = r.footer) == null ? void 0 : t.markdownTotal}:` }),
      /* @__PURE__ */ d.jsx("span", { children: e.length || 0 })
    ] });
  }, [r, e]);
}, ri = (e) => /* @__PURE__ */ d.jsx(
  "div",
  {
    className: Ve([
      `${c}-checkbox`,
      e.checked && `${c}-checkbox-checked`
    ]),
    onClick: () => {
      e.onChange(!e.checked);
    }
  }
), ni = (e) => {
  var t;
  const { usedLanguageText: r } = ne(te);
  return ee(() => {
    var n;
    return /* @__PURE__ */ d.jsxs("div", { className: `${c}-footer-item`, children: [
      /* @__PURE__ */ d.jsx(
        "label",
        {
          className: `${c}-footer-label`,
          onClick: () => {
            e.onScrollAutoChange(!e.scrollAuto);
          },
          children: (n = r.footer) == null ? void 0 : n.scrollAuto
        }
      ),
      /* @__PURE__ */ d.jsx(ri, { checked: e.scrollAuto, onChange: e.onScrollAutoChange })
    ] });
  }, [(t = r.footer) == null ? void 0 : t.scrollAuto, e]);
}, oi = (e) => {
  const r = O(
    (o) => {
      if (en.includes(o))
        switch (o) {
          case "markdownTotal":
            return /* @__PURE__ */ d.jsx(ti, { modelValue: e.modelValue }, "markdown-total");
          case "scrollSwitch":
            return /* @__PURE__ */ d.jsx(
              ni,
              {
                scrollAuto: e.scrollAuto,
                onScrollAutoChange: e.onScrollAutoChange
              },
              "scroll-auto"
            );
        }
      else
        return e.defFooters[o] || "";
    },
    [e.modelValue, e.scrollAuto, e.onScrollAutoChange, e.defFooters]
  ), [t, n] = ee(() => {
    const o = e.footers.indexOf("="), i = o === -1 ? e.footers : e.footers.slice(0, o), l = o === -1 ? [] : e.footers.slice(o, Number.MAX_SAFE_INTEGER);
    return [
      i.map((m) => r(m)),
      l.map((m) => r(m))
    ];
  }, [e.footers, r]);
  return /* @__PURE__ */ d.jsxs("div", { className: `${c}-footer`, children: [
    /* @__PURE__ */ d.jsx("div", { className: `${c}-footer-left`, children: t }),
    /* @__PURE__ */ d.jsx("div", { className: `${c}-footer-right`, children: n })
  ] });
}, ai = ot.memo(oi), te = Xr({
  editorId: "",
  tabWidth: 2,
  theme: "light",
  language: "zh-CN",
  highlight: {
    css: "",
    js: ""
  },
  showCodeRowNumber: !1,
  usedLanguageText: et["zh-CN"],
  previewTheme: "default",
  customIcon: {}
}), Ei = Nr((e, r) => {
  const {
    modelValue: t = H.modelValue,
    theme: n = H.theme,
    className: o = H.className,
    toolbars: i = H.toolbars,
    toolbarsExclude: l = H.toolbarsExclude,
    defToolbars: m = H.defToolbars,
    tabWidth: s = H.tabWidth,
    showCodeRowNumber: a = H.showCodeRowNumber,
    previewTheme: u = H.previewTheme,
    noPrettier: f = H.noPrettier,
    tableShape: b = H.tableShape,
    noMermaid: h = H.noMermaid,
    noKatex: p = H.noKatex,
    placeholder: v = H.placeholder,
    onChange: g = H.onChange,
    onHtmlChanged: x = H.onHtmlChanged,
    onGetCatalog: k = H.onGetCatalog,
    sanitize: $ = H.sanitize,
    onError: C = H.onError,
    mdHeadingId: T = H.mdHeadingId,
    footers: N = H.footers,
    defFooters: P = H.defFooters,
    noIconfont: L = H.noIconfont,
    noUploadImg: D = H.noUploadImg,
    noHighlight: V = H.noHighlight,
    noImgZoomIn: B = H.noImgZoomIn,
    language: Q = H.language,
    inputBoxWitdh: J = H.inputBoxWitdh,
    sanitizeMermaid: Y = H.sanitizeMermaid,
    transformImgUrl: K = H.transformImgUrl,
    codeFoldable: oe = H.codeFoldable,
    autoFoldThreshold: q = H.autoFoldThreshold
  } = e, [M] = _(() => ({
    editorId: e.editorId || Yr(tn + "_"),
    noKatex: p,
    noMermaid: h,
    noPrettier: f,
    noUploadImg: D,
    noIconfont: L,
    noHighlight: V
  })), [X, ae] = _(() => ({
    scrollAuto: e.scrollAuto === void 0 ? !0 : e.scrollAuto
  })), I = F(), E = O(
    (ie) => {
      ae((ue) => ({
        ...ue,
        scrollAuto: ie
      }));
    },
    [ae]
  );
  Hn(e, M), Pn(M), Rn(e, M), Dn(M.editorId, C);
  const A = _n(e, M), [j, z, Z, re] = Fn(e);
  return On(r, M, A, Z, re, I), S(() => () => {
    y.clear(M.editorId);
  }, [M.editorId]), /* @__PURE__ */ d.jsx(
    te.Provider,
    {
      value: {
        editorId: M.editorId,
        tabWidth: s,
        theme: n,
        language: Q,
        highlight: j,
        showCodeRowNumber: a,
        usedLanguageText: z,
        previewTheme: u,
        customIcon: e.customIcon || {}
      },
      children: /* @__PURE__ */ d.jsxs(
        "div",
        {
          id: M.editorId,
          className: Ve([
            c,
            o,
            n === "dark" && `${c}-dark`,
            Z.fullscreen || Z.pageFullscreen ? `${c}-fullscreen` : ""
          ]),
          style: e.style,
          children: [
            i.length > 0 && /* @__PURE__ */ d.jsx(
              oo,
              {
                noPrettier: M.noPrettier,
                toolbars: i,
                toolbarsExclude: l,
                setting: Z,
                updateSetting: re,
                tableShape: b,
                defToolbars: m,
                noUploadImg: M.noUploadImg,
                showToolbarName: e.showToolbarName
              }
            ),
            /* @__PURE__ */ d.jsx(
              ei,
              {
                ref: I,
                modelValue: t,
                onChange: g,
                setting: Z,
                mdHeadingId: T,
                onHtmlChanged: x,
                onGetCatalog: k,
                sanitize: $,
                noMermaid: M.noMermaid,
                noPrettier: M.noPrettier,
                noHighlight: M.noHighlight,
                placeholder: v,
                noKatex: M.noKatex,
                scrollAuto: X.scrollAuto,
                formatCopiedText: e.formatCopiedText,
                autoFocus: e.autoFocus,
                disabled: e.disabled,
                readOnly: e.readOnly,
                maxLength: e.maxLength,
                autoDetectCode: e.autoDetectCode,
                onBlur: e.onBlur,
                onFocus: e.onFocus,
                onInput: e.onInput,
                completions: e.completions,
                catalogVisible: A,
                theme: e.theme,
                noImgZoomIn: B,
                onDrop: e.onDrop,
                inputBoxWitdh: J,
                onInputBoxWitdhChange: e.onInputBoxWitdhChange,
                sanitizeMermaid: Y,
                transformImgUrl: K,
                codeFoldable: oe,
                autoFoldThreshold: q
              }
            ),
            N.length > 0 && /* @__PURE__ */ d.jsx(
              ai,
              {
                modelValue: t,
                footers: N,
                defFooters: P,
                scrollAuto: X.scrollAuto,
                onScrollAutoChange: E
              }
            )
          ]
        }
      )
    }
  );
});
export {
  Ja as C,
  we as D,
  Ei as E,
  Lr as M,
  Jo as S,
  te as a,
  Fn as b,
  Mn as u
};
